var Wt = Object.defineProperty;
var Le = (i) => {
  throw TypeError(i);
};
var Lt = (i, e, t) => e in i ? Wt(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t;
var $ = (i, e, t) => Lt(i, typeof e != "symbol" ? e + "" : e, t), jt = (i, e, t) => e.has(i) || Le("Cannot " + t);
var je = (i, e, t) => e.has(i) ? Le("Cannot add the same private member more than once") : e instanceof WeakSet ? e.add(i) : e.set(i, t);
var Re = (i, e, t) => (jt(i, e, "access private method"), t);
import { defineComponent as V, computed as f, createElementBlock as _, openBlock as c, createCommentVNode as M, renderSlot as J, normalizeStyle as ue, toDisplayString as S, normalizeClass as X, mergeModels as Ee, useModel as De, createVNode as g, unref as l, createBlock as k, Teleport as Te, createElementVNode as h, withModifiers as le, ref as z, Fragment as j, withDirectives as Kt, mergeProps as L, vModelDynamic as Jt, withKeys as at, renderList as Y, withCtx as b, createTextVNode as rt, nextTick as Ie, toRaw as U, toValue as fe, isProxy as Zt, isRef as xe, watch as de, defineAsyncComponent as Xt, resolveDynamicComponent as q, h as Z, reactive as he, shallowReactive as Yt, inject as Be, useCssVars as Ne, normalizeProps as Qt, guardReactiveProps as en, provide as Fe, onMounted as Ue, onUnmounted as st, onBeforeMount as tn, onBeforeUnmount as nn } from "vue";
import { offset as on, shift as ut, flip as dt, useFloating as ct } from "@floating-ui/vue";
import { onClickOutside as ln, useEventListener as pt, useClipboard as an, useMemory as rn, useStorage as sn } from "@vueuse/core";
import { useI18n as un } from "vue-i18n";
import { isEqualWith as dn, get as Se, isUndefined as gt, isNull as cn, groupBy as He, isString as ft, isObjectLike as pn, isPlainObject as gn, merge as vt, throttle as fn, debounce as vn } from "lodash-es";
import { useVueTable as mn, getExpandedRowModel as hn, getFilteredRowModel as bn, getPaginationRowModel as _n, getSortedRowModel as yn, getCoreRowModel as wn, FlexRender as be } from "@tanstack/vue-table";
import { FlexRender as Sa } from "@tanstack/vue-table";
import mt from "@vuepic/vue-datepicker";
import { DynamicScroller as Cn, DynamicScrollerItem as xn } from "vue-virtual-scroller";
import "@vuepic/vue-datepicker/dist/main.css";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
const Sn = { class: "vg-badge" }, Vn = {
  key: 0,
  class: "vg-badge__text"
}, Ge = /* @__PURE__ */ V({
  __name: "VgBadge",
  props: {
    show: { type: Boolean },
    value: {},
    color: {},
    textColor: {},
    position: {},
    size: {},
    fontSize: {}
  },
  setup(i) {
    const e = i, t = f(() => {
      var n, o;
      return {
        color: e.textColor ?? "white",
        backgroundColor: e.color ?? "gray",
        top: ((n = e.position) == null ? void 0 : n.top) ?? "0",
        right: ((o = e.position) == null ? void 0 : o.right) ?? "0",
        width: e.size ?? "8px",
        height: e.size ?? "8px",
        fontSize: e.fontSize ?? "10px"
      };
    });
    return (n, o) => (c(), _("div", Sn, [
      e.show !== !1 ? (c(), _("div", {
        key: 0,
        class: "vg-badge__dot",
        style: ue(t.value)
      }, [
        e.value ? (c(), _("span", Vn, S(e.value), 1)) : M("", !0)
      ], 4)) : M("", !0),
      J(n.$slots, "default")
    ]));
  }
}), kn = ["disabled"], I = /* @__PURE__ */ V({
  __name: "VgButton",
  props: {
    disabled: { type: Boolean },
    active: { type: Boolean },
    rounded: { type: Boolean },
    block: { type: Boolean }
  },
  setup(i) {
    const e = i, t = f(() => ({
      "vg-button": !0,
      "vg-button--disabled": e.disabled,
      "vg-button--active": e.active,
      "vg-button--rounded": e.rounded,
      "vg-button--block": e.block
    }));
    return (n, o) => (c(), _("button", {
      class: X(t.value),
      disabled: n.disabled,
      tabindex: "0"
    }, [
      J(n.$slots, "prepend"),
      J(n.$slots, "default"),
      J(n.$slots, "append")
    ], 10, kn));
  }
}), Dn = ["disabled"], Rn = /* @__PURE__ */ V({
  __name: "VgCheckbox",
  props: /* @__PURE__ */ Ee({
    disabled: { type: Boolean },
    size: {}
  }, {
    modelValue: { type: Boolean },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(i) {
    const e = i, t = De(i, "modelValue"), n = f(() => ({
      "vg-checkbox": !0,
      "vg-checkbox--disabled": e.disabled
    }));
    return (o, r) => (c(), _("button", {
      role: "checkbox",
      class: X(n.value),
      disabled: e.disabled,
      onClick: r[0] || (r[0] = (a) => t.value = !t.value)
    }, [
      g(l(D), {
        type: t.value ? "checkbox-marked" : "checkbox-blank-outline"
      }, null, 8, ["type"])
    ], 10, Dn));
  }
}), An = /* @__PURE__ */ V({
  __name: "VgDrawer",
  props: {
    value: { type: Boolean }
  },
  emits: ["close"],
  setup(i, { emit: e }) {
    const t = i, n = e;
    function o() {
      n("close");
    }
    return (r, a) => (c(), k(Te, { to: "body" }, [
      t.value ? (c(), _("div", {
        key: 0,
        class: "vg-drawer-overlay",
        onClick: o
      }, [
        h("div", {
          class: "vg-drawer-content",
          onClick: a[0] || (a[0] = le(() => {
          }, ["stop"]))
        }, [
          J(r.$slots, "default")
        ])
      ])) : M("", !0)
    ]));
  }
}), pe = /* @__PURE__ */ V({
  __name: "VgDropdown",
  props: /* @__PURE__ */ Ee({
    floatingOptions: {},
    disableCloseOnOutsideClick: { type: Boolean },
    offset: {},
    zindex: {}
  }, {
    modelValue: { type: Boolean, default: !1 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(i) {
    const e = i, t = De(i, "modelValue"), n = z(null), o = z(null), r = e.floatingOptions || {};
    e.floatingOptions || (r.middleware = [on(e.offset ?? 4), ut(), dt()]);
    const { floatingStyles: a } = ct(n, o, r);
    return (s, u) => (c(), _(j, null, [
      h("div", {
        ref_key: "dropdownActivatorRef",
        ref: n,
        class: "vg-dropdown-activator",
        onClick: u[0] || (u[0] = le((v) => t.value = !t.value, ["stop"]))
      }, [
        J(s.$slots, "dropdown-anchor", { dropdownActive: t.value })
      ], 512),
      (c(), k(Te, { to: "body" }, [
        t.value ? (c(), _("div", {
          key: 0,
          class: "vg-dropdown-scrim",
          onClick: u[1] || (u[1] = (v) => t.value = !1),
          style: ue({ zIndex: (e.zindex ?? 2e3) - 1 })
        }, null, 4)) : M("", !0),
        t.value ? (c(), _("div", {
          key: 1,
          class: "vg-dropdown-content",
          style: ue({
            ...l(a),
            zIndex: e.zindex ?? 2e3
          }),
          ref_key: "dropdownRef",
          ref: o
        }, [
          J(s.$slots, "default", { dropdownActive: t.value })
        ], 4)) : M("", !0)
      ]))
    ], 64));
  }
}), oe = /* @__PURE__ */ V({
  __name: "VgInput",
  props: {
    modelValue: {},
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(i, { expose: e }) {
    const t = De(i, "modelValue"), n = z(null), o = i;
    return e({
      inputRef: n
    }), (r, a) => Kt((c(), _("input", L({
      "onUpdate:modelValue": a[0] || (a[0] = (s) => t.value = s)
    }, o, {
      ref_key: "inputRef",
      ref: n,
      class: "vg-input"
    }), null, 16)), [
      [Jt, t.value]
    ]);
  }
}), In = {
  key: 0,
  class: "vg-loader"
}, Fn = /* @__PURE__ */ V({
  __name: "VgLoader",
  props: {
    loading: { type: Boolean }
  },
  setup(i) {
    const e = i;
    return (t, n) => e.loading ? (c(), _("div", In)) : M("", !0);
  }
}), $n = ["onKeydown"], On = {
  key: 0,
  class: "vg-select-anchor-label"
}, se = /* @__PURE__ */ V({
  __name: "VgSelect",
  props: /* @__PURE__ */ Ee({
    items: {},
    disabled: { type: Boolean },
    name: {},
    itemTitle: {},
    itemValue: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(i) {
    const e = De(i, "modelValue"), t = i, n = z(null), o = z(null), r = z(null), a = t.itemTitle ?? "title", s = t.itemValue ?? "value", u = z(""), v = f(() => u.value ? t.items.filter((P) => P[t.itemTitle ?? "title"].toLowerCase().includes(u.value.toLowerCase())) : t.items), { floatingStyles: p } = ct(o, r, {
      middleware: [dt(), ut()]
    }), d = f(() => {
      var P;
      return {
        ...p.value,
        width: (((P = o.value) == null ? void 0 : P.clientWidth) ?? 400) + "px"
      };
    }), m = f(() => ({
      "vg-select-anchor-icon": !0,
      "vg-select-anchor-icon--active": x.value
    })), x = z(!1), w = f(() => {
      const P = t.items.find((T) => JSON.stringify(T[s]) === JSON.stringify(e.value));
      return P && P[s] !== null ? P[a] : "";
    });
    function R(P) {
      e.value = P[s], x.value = !1, u.value = "";
    }
    function y() {
      x.value = !0, Ie(() => {
        var P, T;
        (T = (P = n.value) == null ? void 0 : P.inputRef) == null || T.focus();
      });
    }
    function O(P, T) {
      var C;
      P < 0 ? P = T.length - 1 : P >= T.length && (P = 0), (C = T[P]) == null || C.focus();
    }
    function G(P) {
      var T;
      if (P.key === "Escape")
        x.value = !1, u.value = "";
      else if (P.key === "ArrowDown" || P.key === "ArrowUp" || P.key === "Tab") {
        const C = Array.from(((T = r.value) == null ? void 0 : T.querySelectorAll(".vg-button")) ?? []), F = document.activeElement;
        let A;
        F ? A = C.indexOf(F) : A = -1, P.preventDefault(), P.stopPropagation(), P.key === "ArrowDown" || P.key === "Tab" && !P.shiftKey ? O(A + 1, C) : (P.key === "ArrowUp" || P.key === "Tab" && P.shiftKey) && O((A === -1 ? 0 : A) - 1, C);
      }
    }
    return ln(
      r,
      () => {
        x.value = !1, u.value = "";
      },
      {
        ignore: [o]
      }
    ), (P, T) => (c(), _("div", {
      class: "vg-select",
      role: "button",
      onKeydown: at(le(y, ["prevent"]), ["space"]),
      onClick: y
    }, [
      h("div", {
        class: "vg-select-anchor",
        tabindex: "0",
        ref_key: "anchorRef",
        ref: o
      }, [
        x.value ? (c(), k(l(oe), {
          key: 1,
          modelValue: u.value,
          "onUpdate:modelValue": T[0] || (T[0] = (C) => u.value = C),
          ref_key: "inputRef",
          ref: n,
          onKeydown: G
        }, null, 8, ["modelValue"])) : (c(), _("div", On, S(w.value), 1)),
        h("div", {
          class: X(m.value)
        }, [
          g(l(D), { type: "chevron-down" })
        ], 2)
      ], 512),
      x.value ? (c(), k(Te, {
        key: 0,
        to: "body"
      }, [
        h("div", {
          class: "vg-select-content vg-scrollbar",
          ref_key: "contentRef",
          ref: r,
          style: ue(d.value),
          onKeydown: G
        }, [
          (c(!0), _(j, null, Y(v.value, (C, F) => (c(), k(l(I), {
            class: "vg-select-content-item",
            block: "",
            onClick: () => R(C),
            active: JSON.stringify(C[l(s)]) === JSON.stringify(e.value),
            disabled: C.disabled,
            title: C[l(a)],
            key: F
          }, {
            default: b(() => [
              rt(S(C[l(a)]), 1)
            ]),
            _: 2
          }, 1032, ["onClick", "active", "disabled", "title"]))), 128))
        ], 36)
      ])) : M("", !0)
    ], 40, $n));
  }
}), ht = {
  yes: "ano",
  no: "ne",
  loading: "Načítání...",
  pagination: {
    goToPage: "jít na stranu",
    itemsPerPage: "počet záznamů",
    of: "z",
    totalRowCount: "Záznamů",
    all: "Vše"
  },
  filter: {
    no_filter: "Žádný filtr",
    boolean: {
      all: "Vše",
      true: "Ano",
      false: "Ne"
    },
    advanced_filter: {
      reset: "Smazat",
      save: "Uložit",
      tooltips: {
        main: "Pokročilý filtr"
      }
    },
    select_advanced: {
      active: "aktivní"
    },
    datetime: {
      cancel: "Zrušit",
      select: "Vybrat"
    }
  },
  more_menu: {
    toggle_filters: "Zobrazit/skrýt filtry",
    clear_filter: "Vymazat filtr",
    clear_sorter: "Vymazat řazení",
    sort_ascending: "Řadit vzestupně",
    sort_descending: "Řadit sestupně",
    move_left: "Přesunout doleva",
    move_right: "Přesunout doprava",
    unpin: "Odepnout",
    pin_left: "Připnout vlevo",
    pin_right: "Připnout vpravo",
    hide: "Skrýt",
    tooltips: {
      main: "Více"
    }
  },
  relation: {
    equal: "Rovná se",
    not_equal: "Nerovná se",
    bigger_than: "Větší než",
    bigger_than_or_equal: "Větší nebo rovno",
    smaller_than: "Menší než",
    smaller_than_or_equal: "Menší nebo rovno"
  },
  top_menu: {
    hide_all: "Skrýt všechny",
    show_all: "Zobrazit všechny",
    bold: "Tučně",
    font_family: "Písmo",
    font_size: "Velikost písma",
    row_height: "Výška řádku",
    grid_content_height: "Výška obsahu",
    reset_settings: {
      column_order: "Pořadí sloupců",
      column_pinning: "Připnutí sloupců",
      column_sizing: "Velikost sloupců",
      column_sorting: "Řazení",
      column_visibility: "Viditelnost sloupců",
      accessibility: "Přístupnost",
      all: "Obnovit vše"
    },
    tooltips: {
      clear_filters: "Vymazat všechny filtry",
      column_visibility: "Viditelnost sloupců",
      delete: "Smazat",
      export: "Export",
      copy_to_clipboard: "Zkopírovat do schránky",
      copied_to_clipboard: "Zkopírováno do schránky",
      fullscreen: "Celá obrazovka",
      global_filters: "Globální filtry",
      enable_detail_drawer: "Zobrazit detail po kliknutí",
      reset_settings: "Obnovení uživatelského nastavení",
      header_drag_and_drop: "Přetahování hlaviček sloupců",
      line_height: "Výška řádku",
      publish: "Publikovat",
      refresh: "Obnovit",
      save: "Uložit",
      accessibility: "Přístupnost",
      edit: "Upravit"
    }
  },
  header: {
    tooltips: {
      sort: "Řadit"
    }
  },
  expand: {
    tooltips: {
      compact: "Sbalit",
      expand: "Rozbalit"
    }
  },
  select: {
    tooltips: {
      select: "Vybrat",
      selected: "Vybráno",
      some_selected: "Vybráno"
    }
  },
  infinity_scroll: {
    retry: "Žádná další data - zkusit znovu"
  },
  body: {
    add_new_row: "Přidat nový řádek",
    delete_row: "Smazat řádek",
    edit_row: "Upravit řádek"
  }
}, bt = {
  short: {
    hour: "numeric",
    minute: "numeric",
    second: "numeric"
  },
  time: {
    hour: "numeric",
    minute: "numeric"
  },
  date: {
    year: "numeric",
    month: "numeric",
    day: "numeric"
  },
  datetime: {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric"
  }
}, _t = {
  currency: {
    currencySign: "standard",
    style: "currency",
    currency: "CZK"
  }
}, ia = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  datetime: bt,
  message: ht,
  number: _t
}, Symbol.toStringTag, { value: "Module" })), yt = {
  yes: "yes",
  no: "no",
  loading: "Loading...",
  pagination: {
    of: "of",
    goToPage: "go to page",
    itemsPerPage: "items per page",
    totalRowCount: "Records",
    all: "All"
  },
  filter: {
    no_filter: "No filter",
    boolean: {
      all: "All",
      true: "Yes",
      false: "No"
    },
    advanced_filter: {
      reset: "Reset",
      save: "Save",
      tooltips: {
        main: "Advanced filter"
      }
    },
    select_advanced: {
      active: "active"
    },
    datetime: {
      cancel: "Cancel",
      select: "Select"
    }
  },
  more_menu: {
    toggle_filters: "Toggle filters",
    clear_filter: "Clear filter",
    clear_sorter: "Clear sorter",
    sort_ascending: "Sort ascending",
    sort_descending: "Sort descending",
    move_left: "Move left",
    move_right: "Move right",
    unpin: "Unpin",
    pin_left: "Pin left",
    pin_right: "Pin right",
    hide: "Hide",
    tooltips: {
      main: "More"
    }
  },
  relation: {
    equal: "Equal",
    not_equal: "Not equal",
    bigger_than: "Bigger than",
    bigger_than_or_equal: "Bigger than or equal",
    smaller_than: "Smaller than",
    smaller_than_or_equal: "Smaller than or equal"
  },
  top_menu: {
    hide_all: "Hide all",
    show_all: "Show all",
    bold: "Bold",
    font_family: "Font family",
    font_size: "Font size",
    row_height: "Row height",
    grid_content_height: "Grid content height",
    reset_settings: {
      column_order: "Column order",
      column_pinning: "Column pinning",
      column_sizing: "Column sizing",
      column_sorting: "Sorting",
      column_visibility: "Column visibility",
      accessibility: "Accessibility",
      all: "Reset all settings"
    },
    tooltips: {
      clear_filters: "Clear filters",
      column_visibility: "Column visibility",
      delete: "Delete",
      export: "Export",
      fullscreen: "Fullscreen",
      global_filters: "Global filters",
      enable_detail_drawer: "Show detail on click",
      copy_to_clipboard: "Copy to clipboard",
      copied_to_clipboard: "Copied to clipboard",
      reset_settings: "Reset user settings",
      header_drag_and_drop: "Column header drag and drop",
      line_height: "Line height",
      publish: "Publish",
      refresh: "Refresh",
      save: "Save",
      accessibility: "Accessibility",
      edit: "Edit"
    }
  },
  header: {
    tooltips: {
      sort: "Sort"
    }
  },
  expand: {
    tooltips: {
      compact: "Compact",
      expand: "Expand"
    }
  },
  select: {
    tooltips: {
      selected: "Selected",
      select: "Select",
      some_selected: "Some selected"
    }
  },
  infinity_scroll: {
    retry: "No more data - retry"
  },
  body: {
    add_new_row: "Add new row",
    delete_row: "Delete row",
    edit_row: "Edit row"
  }
}, wt = {
  short: {
    hour: "numeric",
    minute: "numeric",
    second: "numeric"
  },
  time: {
    hour: "numeric",
    minute: "numeric"
  },
  date: {
    year: "numeric",
    month: "numeric",
    day: "numeric"
  },
  datetime: {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric"
  }
}, Ct = {
  currency: {
    currencySign: "standard",
    style: "currency",
    currency: "USD"
  }
}, oa = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  datetime: wt,
  message: yt,
  number: Ct
}, Symbol.toStringTag, { value: "Module" })), xt = {
  yes: "áno",
  no: "nie",
  loading: "Načítanie...",
  pagination: {
    goToPage: "prejsť na stránku",
    itemsPerPage: "počet záznamov",
    of: "z",
    totalRowCount: "Záznamov",
    all: "Všetko"
  },
  filter: {
    no_filter: "Žiadny filter",
    boolean: {
      all: "Všetko",
      true: "Áno",
      false: "Nie"
    },
    advanced_filter: {
      reset: "Zmazať",
      save: "Uložiť",
      tooltips: {
        main: "Pokročilý filter"
      }
    },
    select_advanced: {
      active: "aktívny"
    },
    datetime: {
      cancel: "Zrušiť",
      select: "Vybrať"
    }
  },
  more_menu: {
    toggle_filters: "Zobraziť/skryť filtre",
    clear_filter: "Vymazať filter",
    clear_sorter: "Vymazať triedenie",
    sort_ascending: "Zoradiť vzostupne",
    sort_descending: "Zoradiť zostupne",
    move_left: "Presunúť doľava",
    move_right: "Presunúť doprava",
    unpin: "Zrušiť pripnutie",
    pin_left: "Pripnúť vľavo",
    pin_right: "Pripnúť vpravo",
    hide: "Skryť",
    tooltips: {
      main: "Viac"
    }
  },
  relation: {
    equal: "Rovná sa",
    not_equal: "Nerovná sa",
    bigger_than: "Väčší ako",
    bigger_than_or_equal: "Väčší alebo rovný",
    smaller_than: "Menší ako",
    smaller_than_or_equal: "Menšie alebo rovné"
  },
  top_menu: {
    hide_all: "Skryť všetko",
    show_all: "Zobraziť všetko",
    bold: "Tučne",
    font_family: "Písmo",
    font_size: "Veľkosť písma",
    row_height: "Výška riadku",
    grid_content_height: "Výška obsahu",
    reset_settings: {
      column_order: "Poradie stĺpcov",
      column_pinning: "Pripínanie stĺpcov",
      column_sizing: "Veľkosť stĺpca",
      column_sorting: "Radenie",
      column_visibility: "Viditeľnosť stĺpca",
      accessibility: "Prístupnosť",
      all: "Obnoviť všetko"
    },
    tooltips: {
      clear_filters: "Vymazať všetky filtre",
      column_visibility: "Viditeľnosť stĺpcov",
      delete: "Vymazať",
      export: "Export",
      copy_to_clipboard: "Kopírovať do schránky",
      copied_to_clipboard: "Skopírované do schránky",
      fullscreen: "Celá obrazovka",
      global_filters: "Globálne filtre",
      enable_detail_drawer: "Zobraziť detail po kliknutí",
      reset_settings: "Obnoviť užívateľské nastavenia",
      header_drag_and_drop: "Ťahanie záhlaví stĺpcov",
      line_height: "Výška riadku",
      publish: "Publikovať",
      refresh: "Obnoviť",
      save: "Uložiť",
      accessibility: "Prístupnosť",
      edit: "Upraviť"
    }
  },
  header: {
    tooltips: {
      sort: "Triediť"
    }
  },
  expand: {
    tooltips: {
      compact: "Sbaliť",
      expand: "Rozbaliť"
    }
  },
  select: {
    tooltips: {
      select: "Vybrať",
      selected: "Vybrané",
      some_selected: "Vybrané"
    }
  },
  infinity_scroll: {
    retry: "Žiadne ďalšie údaje - skúste to znova"
  },
  body: {
    add_new_row: "Pridať nový riadok",
    delete_row: "Vymazať riadok",
    edit_row: "Upraviť riadok"
  }
}, St = {
  short: {
    hour: "numeric",
    minute: "numeric",
    second: "numeric"
  },
  time: {
    hour: "numeric",
    minute: "numeric"
  },
  date: {
    year: "numeric",
    month: "numeric",
    day: "numeric"
  },
  datetime: {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric"
  }
}, Vt = {
  currency: {
    currencySign: "standard",
    style: "currency",
    currency: "EUR"
  }
}, la = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  datetime: St,
  message: xt,
  number: Vt
}, Symbol.toStringTag, { value: "Module" }));
function Ae(i, e, t) {
  Object.entries(t).forEach(([n, o]) => {
    switch (e) {
      case "message":
        i.mergeLocaleMessage(n, o);
        break;
      case "datetime":
        i.mergeDateTimeFormat(n, o);
        break;
      case "number":
        i.mergeNumberFormat(n, o);
        break;
    }
  });
}
function ae(i) {
  var t, n, o;
  const e = un({
    useScope: "local",
    fallbackLocale: "en",
    inheritLocale: !0,
    messages: {
      cs: ht,
      en: yt,
      sk: xt
    },
    datetimeFormats: {
      cs: bt,
      en: wt,
      sk: St
    },
    numberFormats: {
      cs: _t,
      en: Ct,
      sk: Vt
    }
  });
  return Ae(e, "message", ((t = i == null ? void 0 : i.locales) == null ? void 0 : t.message) ?? {}), Ae(e, "datetime", ((n = i == null ? void 0 : i.locales) == null ? void 0 : n.datetime) ?? {}), Ae(e, "number", ((o = i == null ? void 0 : i.locales) == null ? void 0 : o.number) ?? {}), e;
}
const kt = Symbol(), Dt = Symbol(), Rt = Symbol();
function aa(i, e) {
  for (let t = 0, n = i.length; t < n; t++)
    e(i[t], t, i);
}
function ra(i, e) {
  const { length: t } = i, n = Array.from({ length: t });
  for (let o = 0; o < t; o++)
    n[o] = e(i[o], o, i);
  return n;
}
function Pn(i) {
  return Object.prototype.toString.call(i) === "[object Array]";
}
function At(i) {
  return Object.prototype.toString.call(i) === "[object String]";
}
function $e(i) {
  return Object.prototype.toString.call(i) === "[object Object]";
}
function ve(i) {
  return Object.prototype.toString.call(i) === "[object Function]";
}
function zn(i, e, t) {
  return dn(i, e, (n, o) => {
    if (t != null && t.fields) {
      for (const r of t.fields)
        if (Se(n, r, 1) !== Se(o, r, 2))
          return !1;
      return !0;
    }
  });
}
function Mn(i) {
  return Object.prototype.toString.call(i) === "[object Number]";
}
function sa(i) {
  return Object.prototype.toString.call(i) === "[object Null]";
}
function Q(i) {
  return structuredClone(((e = fe(i)) => Zt(e) ? U(e) : e)());
}
function Ve(i, e) {
  var a, s;
  const { gridApi: t } = H(), n = (i ? (a = t.table.value) == null ? void 0 : a.getLeftLeafColumns() : (s = t.table.value) == null ? void 0 : s.getRightLeafColumns()) ?? [], o = n.findIndex((u) => u.id === e);
  let r = 0;
  return i ? r = n.slice(0, o).reduce((u, v) => u + v.getSize(), 0) : r = n.slice(o + 1).reduce((u, v) => u + v.getSize(), 0), r;
}
function Oe(i) {
  const { gridApi: e, valueFormatter: t, columnDef: n } = _e(i.column);
  return {
    ctx: {
      ...i,
      columnDef: n,
      getFormattedValue() {
        const o = i.table.getColumn(i.column.id), r = o == null ? void 0 : o.accessorFn(i.row.original, i.row.index);
        return (t == null ? void 0 : t(r, { i18n: e.i18n.value, cell: i.cell, grid: e })) ?? r;
      },
      get getValue() {
        const o = i.table.getColumn(i.column.id);
        return () => o == null ? void 0 : o.accessorFn(i.row.original, i.row.index);
      }
    }
  };
}
function En(i) {
  return {
    ctx: i
  };
}
function Tn(i, e, t) {
  if (t)
    return t;
  switch (i) {
    case "text":
      return nt;
    case "boolean":
      return Oi;
    default:
      return nt;
  }
}
const Bn = /* @__PURE__ */ V({
  __name: "VgBooleanFilter",
  props: {
    filterCustomData: {},
    columnId: {},
    index: {},
    gridApi: {},
    isInMenu: { type: Boolean }
  },
  setup(i) {
    var r, a, s;
    const { i18n: e } = H(), t = i, n = t.gridApi.filters.getColumnFilterWriteableData(t.columnId, t.index), o = z([
      {
        title: ((r = t.filterCustomData) == null ? void 0 : r.trueLabel) || e.t("filter.boolean.true"),
        value: !0
      },
      {
        title: ((a = t.filterCustomData) == null ? void 0 : a.falseLabel) || e.t("filter.boolean.false"),
        value: !1
      },
      {
        title: ((s = t.filterCustomData) == null ? void 0 : s.emptyLabel) || e.t("filter.boolean.all"),
        value: null
      }
    ]);
    return (u, v) => (c(), k(l(se), {
      modelValue: l(n),
      "onUpdate:modelValue": v[0] || (v[0] = (p) => xe(n) ? n.value = p : null),
      items: o.value
    }, null, 8, ["modelValue", "items"]));
  }
}), Nn = /* @__PURE__ */ V({
  __name: "VgComboFilter",
  props: {
    filterCustomData: {},
    columnId: {},
    index: {},
    gridApi: {},
    isInMenu: { type: Boolean }
  },
  setup(i) {
    const e = f(() => o.value === !0 ? "checkbox-marked" : o.value === !1 ? "close-box" : "checkbox-blank-outline");
    function t() {
      o.value === !0 ? o.value = !1 : o.value === !1 ? o.value = null : o.value = !0;
    }
    const n = i, o = n.gridApi.filters.getColumnFilterWriteableData(n.columnId, n.index);
    return (r, a) => (c(), _("div", { onClick: t }, [
      g(l(D), { type: e.value }, null, 8, ["type"])
    ]));
  }
}), Un = /* @__PURE__ */ V({
  __name: "VgDateFilter",
  props: {
    filterCustomData: {},
    columnId: {},
    index: {},
    gridApi: {},
    isInMenu: { type: Boolean }
  },
  setup(i) {
    const e = ae(), t = i;
    function n(a) {
      var s;
      return e.d(a, ((s = t.filterCustomData.filterOptions) == null ? void 0 : s.dateType) ?? "datetime");
    }
    const o = t.gridApi.filters.getColumnFilterWriteableData(t.columnId, t.index), r = f({
      get() {
        return o.value instanceof Date ? o.value : typeof o.value == "string" ? new Date(o.value) : null;
      },
      set(a) {
        if (a && a.hours !== void 0 && a.minutes !== void 0) {
          const s = /* @__PURE__ */ new Date();
          s.setHours(a.hours), s.setMinutes(a.minutes), s.setSeconds(0), o.value = s;
        } else
          o.value = a;
      }
    });
    return (a, s) => {
      var u, v;
      return c(), k(l(mt), {
        modelValue: r.value,
        "onUpdate:modelValue": s[0] || (s[0] = (p) => r.value = p),
        locale: l(e).locale.value,
        style: { width: "100%", height: "100%" },
        "select-text": l(e).t("filter.datetime.select"),
        "cancel-text": l(e).t("filter.datetime.cancel"),
        "time-picker": ((u = t.filterCustomData.filterOptions) == null ? void 0 : u.dateType) === "time",
        "enable-time-picker": ((v = t.filterCustomData.filterOptions) == null ? void 0 : v.dateType) !== "date",
        format: n,
        teleport: !t.isInMenu
      }, null, 8, ["modelValue", "locale", "select-text", "cancel-text", "time-picker", "enable-time-picker", "teleport"]);
    };
  }
}), Hn = /* @__PURE__ */ V({
  __name: "VgNumberFilter",
  props: {
    filterCustomData: {},
    columnId: {},
    index: {},
    gridApi: {},
    isInMenu: { type: Boolean }
  },
  setup(i) {
    const e = i, t = e.gridApi.filters.getColumnFilterWriteableData(e.columnId, e.index), n = z(U(t.value ?? "")), o = z(null);
    de(
      () => t.value,
      (a) => {
        n.value = a;
      }
    );
    function r() {
      t.value = n.value !== "" ? n.value : null;
    }
    return pt(o, "keydown", (a) => {
      a.key === "Enter" && r();
    }), (a, s) => (c(), k(l(oe), L({
      modelValue: n.value,
      "onUpdate:modelValue": s[0] || (s[0] = (u) => n.value = u),
      modelModifiers: { number: !0 }
    }, e.filterCustomData, {
      ref_key: "inputElement",
      ref: o,
      onFocusout: r
    }), null, 16, ["modelValue"]));
  }
}), Gn = /* @__PURE__ */ V({
  __name: "VgSelectFilter",
  props: {
    filterCustomData: {},
    columnId: {},
    index: {},
    gridApi: {},
    isInMenu: { type: Boolean }
  },
  setup(i) {
    const e = i, { i18n: t } = H(), n = f(() => {
      const s = e.filterCustomData.filterOptions;
      return s != null && s.find((u) => u[a.value] === null) ? s : [{ [r.value]: t.t("filter.no_filter"), [a.value]: null }, ...s ?? []];
    }), o = e.gridApi.filters.getColumnFilterWriteableData(e.columnId, e.index), r = f(() => e.filterCustomData.itemTitle ?? "title"), a = f(() => e.filterCustomData.itemValue ?? "value");
    return (s, u) => (c(), k(l(se), {
      modelValue: l(o),
      "onUpdate:modelValue": u[0] || (u[0] = (v) => xe(o) ? o.value = v : null),
      items: n.value,
      "item-title": r.value,
      "item-value": a.value
    }, null, 8, ["modelValue", "items", "item-title", "item-value"]));
  }
}), Ke = /* @__PURE__ */ V({
  __name: "VgTextFilter",
  props: {
    filterCustomData: {},
    columnId: {},
    index: {},
    gridApi: {},
    isInMenu: { type: Boolean }
  },
  setup(i) {
    const e = i, t = e.gridApi.filters.getColumnFilterWriteableData(e.columnId, e.index), n = z(U(t.value ?? "")), o = z(null);
    de(
      () => t.value,
      (a) => {
        n.value = a;
      }
    );
    function r() {
      t.value = n.value !== "" ? n.value : null;
    }
    return pt(o, "keydown", (a) => {
      a.key === "Enter" && r();
    }), (a, s) => (c(), k(l(oe), L({
      modelValue: n.value,
      "onUpdate:modelValue": s[0] || (s[0] = (u) => n.value = u)
    }, e.filterCustomData, {
      ref_key: "inputElement",
      ref: o,
      onFocusout: r
    }), null, 16, ["modelValue"]));
  }
}), It = /* @__PURE__ */ Object.assign({
  "./svg/add-row.svg": () => import("./add-row-C8sfTbv0.js"),
  "./svg/adjusment-horizontal.svg": () => import("./adjusment-horizontal-CSye2WHw.js"),
  "./svg/adjusment-vertical.svg": () => import("./adjusment-vertical-CQMkvzak.js"),
  "./svg/arrow-down.svg": () => import("./arrow-down-DoMzNMl8.js"),
  "./svg/arrow-expand-horizontal.svg": () => import("./arrow-expand-horizontal-PbXqQ6Rz.js"),
  "./svg/arrow-up.svg": () => import("./arrow-up-Cn8l-Qgm.js"),
  "./svg/calendar-month.svg": () => import("./calendar-month-BiCQ7b12.js"),
  "./svg/checkbox-blank-outline.svg": () => import("./checkbox-blank-outline-D2kjB9o-.js"),
  "./svg/checkbox-marked.svg": () => import("./checkbox-marked-CEDKCSaE.js"),
  "./svg/chevron-double-left.svg": () => import("./chevron-double-left-BpHXKpf2.js"),
  "./svg/chevron-double-right.svg": () => import("./chevron-double-right-LcQw_UHz.js"),
  "./svg/chevron-down.svg": () => import("./chevron-down-BnDoACbL.js"),
  "./svg/chevron-left.svg": () => import("./chevron-left-BgDrCqST.js"),
  "./svg/chevron-right.svg": () => import("./chevron-right-Dy4dgk3D.js"),
  "./svg/chevron-up-down.svg": () => import("./chevron-up-down-B56I81xf.js"),
  "./svg/clipboard-document.svg": () => import("./clipboard-document-R1oBTpmV.js"),
  "./svg/close-box.svg": () => import("./close-box-C8bbvX-R.js"),
  "./svg/close.svg": () => import("./close-B_gy2HJB.js"),
  "./svg/cog-outline.svg": () => import("./cog-outline-DL59mka7.js"),
  "./svg/content-save-outline.svg": () => import("./content-save-outline-Vw8lfz2Q.js"),
  "./svg/controls-next.svg": () => import("./controls-next-DxOg0zTW.js"),
  "./svg/controls-prev.svg": () => import("./controls-prev-CrHRiRcW.js"),
  "./svg/drag.svg": () => import("./drag-CJL_XljL.js"),
  "./svg/eye-off-outline.svg": () => import("./eye-off-outline-Dbht4aW3.js"),
  "./svg/eye-outline.svg": () => import("./eye-outline-BqMT9j-o.js"),
  "./svg/file-export-outline.svg": () => import("./file-export-outline-S7HfqWxk.js"),
  "./svg/filter-remove-outline.svg": () => import("./filter-remove-outline-N7NKUHZA.js"),
  "./svg/filter.svg": () => import("./filter-Dvja01aR.js"),
  "./svg/folder-upload-outline.svg": () => import("./folder-upload-outline-DZmOu3tN.js"),
  "./svg/format-bold.svg": () => import("./format-bold-Cxqcs9QY.js"),
  "./svg/format-font.svg": () => import("./format-font-OKL_6bQY.js"),
  "./svg/format-line-spacing.svg": () => import("./format-line-spacing-lUUVK5Xb.js"),
  "./svg/fullscreen.svg": () => import("./fullscreen-Cl0udaBa.js"),
  "./svg/funnel.svg": () => import("./funnel-BSjbfWXK.js"),
  "./svg/grid-detail-icon.svg": () => import("./grid-detail-icon-BJ9PpuV7.js"),
  "./svg/lock-left.svg": () => import("./lock-left-D2khebQ_.js"),
  "./svg/lock-open-outline.svg": () => import("./lock-open-outline-DYsExWPL.js"),
  "./svg/lock-right.svg": () => import("./lock-right-CS3HE-L3.js"),
  "./svg/minus-box.svg": () => import("./minus-box-DZCVVxok.js"),
  "./svg/more-vertical.svg": () => import("./more-vertical-B7bSuLm_.js"),
  "./svg/move-column.svg": () => import("./move-column-CFsgmWEk.js"),
  "./svg/pencil-outline.svg": () => import("./pencil-outline-DeVTkWVw.js"),
  "./svg/refresh.svg": () => import("./refresh-CA0rPCxO.js"),
  "./svg/trash-can-outline.svg": () => import("./trash-can-outline-DDQt-V89.js"),
  "./svg/tune.svg": () => import("./tune-Hhv_pbdE.js"),
  "./svg/user-reload.svg": () => import("./user-reload-Dmjn6lyc.js")
});
function Ft(i) {
  return `./svg/${i}.svg`;
}
function qn(i) {
  return Object.prototype.hasOwnProperty.call(It, Ft(i));
}
function Wn(i) {
  return It[Ft(i)];
}
const Ln = ["icon-type"], D = /* @__PURE__ */ V({
  __name: "VgIcon",
  props: {
    type: {}
  },
  setup(i) {
    const e = i, t = f(() => qn(e.type) ? Xt(Wn(e.type)) : null);
    return (n, o) => (c(), _("div", {
      class: "vg-icon",
      "icon-type": e.type
    }, [
      t.value ? (c(), k(q(t.value), { key: 0 })) : M("", !0)
    ], 8, Ln));
  }
}), ua = {
  type: {
    type: String,
    required: !0
  }
}, jn = { class: "vg-column-filter-advanced-wrapper" }, Kn = {
  key: 0,
  class: "vg-column-advanced-filter-button"
}, Jn = { class: "vg-column-advanced-filter-container" }, Zn = { class: "vg-column-advanced-filter-button-wrapper" }, Xn = /* @__PURE__ */ V({
  __name: "VgColumnFilterWrapper",
  props: {
    column: {
      type: Object,
      required: !0
    },
    columnDef: {
      type: Object,
      required: !0
    }
  },
  setup(i) {
    const { gridApi: e, i18n: t } = H(), n = i, o = e.filters.getColumnFilterWriteableRelation(n.column.id, 0), r = e.filters.getColumnFilterWriteableRelation(n.column.id, 1), a = f(() => o.value !== ee(n.columnDef.relationOverride) || r.value !== ee(n.columnDef.relationOverride)), s = $t(n.columnDef.columnType, e, n.columnDef.filter), u = n.columnDef.relationOverride ?? [
      {
        title: t.t("relation.equal"),
        value: "equal"
      },
      {
        title: t.t("relation.not_equal"),
        value: "notEqual"
      },
      {
        title: t.t("relation.bigger_than"),
        value: "biggerThan"
      },
      {
        title: t.t("relation.smaller_than"),
        value: "smallerThan"
      },
      {
        title: t.t("relation.bigger_than_or_equal"),
        value: "biggerThanOrEqual"
      },
      {
        title: t.t("relation.smaller_than_or_equal"),
        value: "smallerThanOrEqual"
      }
    ];
    async function v() {
      await e.filters.clearFilter(n.column.id);
    }
    return (p, d) => (c(), _("div", jn, [
      (c(), k(q(l(s)), {
        "column-id": n.column.id,
        index: 0,
        "filter-custom-data": n.columnDef.columnFilterCustomData ?? {},
        "grid-api": l(e),
        "is-in-menu": !1
      }, null, 8, ["column-id", "filter-custom-data", "grid-api"])),
      n.columnDef.columnFilterAdvanced ? (c(), _("div", Kn, [
        g(l(pe), null, {
          "dropdown-anchor": b(({ dropdownActive: m }) => [
            g(l(I), {
              title: l(t).t("filter.advanced_filter.tooltips.main"),
              active: m || l(e).filters.getColumnFilterWriteableData(n.column.id, 1).value || a.value
            }, {
              default: b(() => [
                g(l(D), { type: "filter" })
              ]),
              _: 2
            }, 1032, ["title", "active"])
          ]),
          default: b(() => [
            h("div", Jn, [
              g(l(se), {
                modelValue: l(o),
                "onUpdate:modelValue": d[0] || (d[0] = (m) => xe(o) ? o.value = m : null),
                items: l(u),
                class: "vg-column-filter-advanced-wrapper-select"
              }, null, 8, ["modelValue", "items"]),
              (c(), k(q(l(s)), {
                "column-id": n.column.id,
                index: 0,
                "filter-custom-data": n.columnDef.columnFilterCustomData ?? {},
                "grid-api": l(e),
                "is-in-menu": !0
              }, null, 8, ["column-id", "filter-custom-data", "grid-api"])),
              d[2] || (d[2] = h("hr", { class: "vg-divider-horizontal" }, null, -1)),
              g(l(se), {
                modelValue: l(r),
                "onUpdate:modelValue": d[1] || (d[1] = (m) => xe(r) ? r.value = m : null),
                items: l(u),
                class: "vg-column-filter-advanced-wrapper-select"
              }, null, 8, ["modelValue", "items"]),
              (c(), k(q(l(s)), {
                "column-id": n.column.id,
                index: 1,
                "filter-custom-data": n.columnDef.columnFilterCustomData ?? {},
                "grid-api": l(e),
                "is-in-menu": !0
              }, null, 8, ["column-id", "filter-custom-data", "grid-api"])),
              d[3] || (d[3] = h("hr", { class: "vg-divider-horizontal" }, null, -1)),
              h("div", Zn, [
                g(l(I), {
                  onClick: v,
                  block: ""
                }, {
                  default: b(() => [
                    g(l(D), { type: "trash-can-outline" }),
                    h("p", null, S(l(t).t("filter.advanced_filter.reset")), 1)
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        })
      ])) : M("", !0)
    ]));
  }
});
function $t(i, e, t) {
  var o;
  if (t)
    return t;
  const n = ((o = e.config.componentsPool) == null ? void 0 : o.filterType) ?? {};
  switch (i) {
    case "text":
      return Ke;
    case "select":
      return Gn;
    case "boolean":
      return Bn;
    case "date":
      return Un;
    case "number":
      return Hn;
    case "combo":
      return Nn;
    default:
      if (i && n[i]) {
        const r = n[i];
        if (r)
          return r;
      }
      return Ke;
  }
}
function Yn(i) {
  return {
    vgBodyRow: ot,
    vgBodyRowSub: ot,
    vgBodyRowDetail: uo,
    vgHeaderRow: Lo,
    ...i ?? {}
  };
}
function Qn(i) {
  const e = (t, n) => Se(i, t, n);
  return {
    pageCountOptions: e(
      "pageCountOptions",
      Array.from({ length: 10 }, (t, n) => (n + 1) * 10)
    ),
    getData: e("getData", () => ({ data: [], pageCount: 0 })),
    suppressGetRowsInitially: e("suppressGetRowsInitially", !1),
    sortingState: e("sortingState", []),
    columnFiltersState: e("columnFiltersState", []),
    paginationState: {
      pageIndex: e("paginationState.pageIndex", 0),
      pageSize: e("paginationState.pageSize", 30)
    }
  };
}
function ne(i, e) {
  return ve(i) ? i(e) : i;
}
function Pe(i) {
  const e = _e(i.column), { gridApi: t, columnDef: n } = e, o = i.getValue();
  return n != null && n.valueFormatterCopyToClipboard ? n.valueFormatterCopyToClipboard(o, { i18n: t.i18n.value, cell: i, grid: t }) : gt(o) || cn(o) ? void 0 : o;
}
function Ot(i) {
  let e = "";
  const t = i.length;
  return i.forEach((n, o) => {
    n.forEach((r, a) => {
      gt(r) ? e += "	" : (e += `${r}`, a < n.length && (e += "	"));
    }), o < t && (e += `
`);
  }), e;
}
function ei(i) {
  if (i.length === 0)
    return !0;
  const e = i[0].map((t) => t.column.id);
  for (const t of i.slice(1))
    if (!(t.length === e.length && t.map((n) => n.column.id).every((n) => e.includes(n))))
      return !1;
  return !0;
}
function ti(i) {
  const e = Object.values(
    He(
      i.slice().sort((n, o) => n.row.index - o.row.index),
      (n) => n.row.id
    )
  );
  if (e.length === 0)
    return "";
  let t = [[]];
  return ei(e) ? t = e.map((n) => n.map((o) => Pe(o))) : t = e.map((n) => n.map((o) => [Pe(o)])).flat(1), Ot(t);
}
function ni(i) {
  const e = i.split("__"), t = e.pop(), n = (t == null ? void 0 : t.split("_")) ?? [], o = n[0] ?? "", r = n.slice(1).join("_");
  return {
    rowId: [...e, o].filter(Boolean).join("__"),
    columnId: r
  };
}
function Je(i) {
  return ft(i) ? i : i.id;
}
function ii(i) {
  const e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Map();
  function n() {
    e.forEach((C) => {
      r(C);
    });
  }
  function o(C) {
    return e.has(Je(C));
  }
  function r(C) {
    var E, W;
    const F = Je(C);
    e.delete(F);
    const A = t.get(F);
    (E = A == null ? void 0 : A.onDeselect) == null || E.call(A), (W = A == null ? void 0 : A.onChange) == null || W.call(A, !1);
  }
  function a(C) {
    ft(C) ? s(C) : u(C);
  }
  function s(C) {
    var B, N, We;
    const { rowId: F } = ni(C), A = (B = i.table.value) == null ? void 0 : B.getRow(F);
    if (!A) return;
    const E = A.getAllCells().find((qt) => qt.id === C);
    if (!E) return;
    e.set(E.id, E);
    const W = t.get(E.id);
    (N = W == null ? void 0 : W.onSelect) == null || N.call(W), (We = W == null ? void 0 : W.onChange) == null || We.call(W, !0);
  }
  function u(C) {
    var A, E;
    e.set(C.id, C);
    const F = t.get(C.id);
    (A = F == null ? void 0 : F.onSelect) == null || A.call(F), (E = F == null ? void 0 : F.onChange) == null || E.call(F, !0);
  }
  function v(C, F) {
    const A = F.id;
    C.ctrlKey ? e.has(A) ? r(A) : a(A) : e.has(A) ? (e.size > 1 && n(), r(A)) : (n(), a(A));
  }
  function p(C, F) {
    t.set(C, F);
  }
  function d(C) {
    t.delete(C);
  }
  function m() {
    return [...e.values()].sort((C, F) => {
      const A = C.row.index - F.row.index, E = C.column.getIndex() - F.column.getIndex();
      return A === 0 ? E : A;
    });
  }
  function x() {
    return Object.values(He(m(), (C) => C.row.id));
  }
  function w() {
    return x().map((C) => C.map((F) => F.getValue()));
  }
  function R() {
    return e.size > 0;
  }
  function y() {
    const { rows: C } = i.table.value.getRowModel();
    C.forEach((F) => {
      F.getVisibleCells().forEach((E) => {
        a(E);
      });
    });
  }
  async function O(C) {
    if (!i.editing.value && (C.ctrlKey && C.code === "KeyA" && R() && (C.preventDefault(), y()), C.ctrlKey && C.code === "KeyC" && R())) {
      C.preventDefault();
      const F = await G();
      await i.utils.clipboard.copy(F);
    }
  }
  async function G() {
    var F, A;
    const C = m();
    return ((A = (F = i.config.copyToClipboardConfig) == null ? void 0 : F.getClipboardContent) == null ? void 0 : A.call(F, C, i)) ?? ti(C);
  }
  function P() {
    window.document.addEventListener("keydown", O);
  }
  function T() {
    var C;
    e.clear(), t.clear(), (C = i.bodyElement.value) == null || C.removeEventListener("keydown", O);
  }
  return {
    getSelectedCells: m,
    getClipboardString: G,
    hasSelectedCells: R,
    isSelectedCell: o,
    bindCellInstanceHandlers: p,
    unbindCellInstanceHandlers: d,
    selectCell: a,
    selectAllCells: y,
    deselectCell: r,
    deselectAllSelectedCells: n,
    getSelectedCellsValuesAs2DArray: w,
    onCellClickHandler: v,
    init: P,
    destroy: T
  };
}
const qe = Symbol("VG-ROW-DETAIL"), Pt = "VG-ROW-DETAIL", zt = new RegExp(`^(.+)__${Pt}$`), Mt = 40, Et = 50, Tt = 50;
function oi(i) {
  const { columns: e } = i.config, t = e.map((n) => ge(n, i));
  return i.config.enableExpanding && t.unshift(
    ge(
      {
        id: "vg-row-expander",
        valueGetter: null,
        enableResizing: !1,
        size: Mt,
        header: (n) => Z(Bo, n),
        cell: (n) => Z(Xi, n),
        editable: !1,
        showDetailDrawerOnClick: !1
      },
      i
    )
  ), i.config.enableSelection && t.unshift(
    ge(
      {
        id: "vg-row-selection",
        valueGetter: null,
        enableResizing: !1,
        size: Et,
        header: (n) => Z(Uo, n),
        cell: (n) => Z(Qi, n),
        editable: !1,
        showDetailDrawerOnClick: !1
      },
      i
    )
  ), i.config.enableRowDragAndDrop && t.unshift(
    ge(
      {
        id: "vg-row-drag-handle",
        valueGetter: null,
        enableResizing: !1,
        size: Tt,
        cell: (n) => Z(Gi, n),
        header: (n) => Z(Eo, n),
        editable: !1,
        showDetailDrawerOnClick: !1
      },
      i
    )
  ), t;
}
function li(i) {
  var u, v, p;
  const { gridApi: e } = i;
  function t(d, m) {
    return e.storageController.bindKey(d, m);
  }
  const n = fe(e.datasource.paginationState.pageIndex), o = fe(e.datasource.paginationState.pageCount), r = t("pagination", {
    pageIndex: e.datasource.paginationState.pageIndex,
    pageSize: e.datasource.paginationState.pageSize
  });
  r.value.pageIndex = n, o !== void 0 && (r.value.pageCount = o);
  const a = he({
    columnOrder: t("columnOrder", []),
    columnPinning: t("columnPinning", {}),
    columnFilters: [],
    grouping: t("grouping", []),
    columnVisibility: t("columnVisibility", {}),
    expanded: t("expanded", {}),
    globalFilter: t("globalFilter", null),
    rowSelection: {},
    columnSizing: t("columnSizing", {}),
    rowPinning: t("rowPinning", {}),
    columnSizingInfo: {
      columnSizingStart: [],
      isResizingColumn: !1,
      startSize: null,
      startOffset: null,
      deltaOffset: null,
      deltaPercentage: null
    },
    pagination: r,
    sorting: t("sorting", e.datasource.sortingState)
  });
  return {
    table: mn({
      get data() {
        return fe(e.state.data);
      },
      /* STATE */
      state: {
        get sorting() {
          return a.sorting;
        },
        get pagination() {
          return a.pagination;
        },
        get columnSizingInfo() {
          return a.columnSizingInfo;
        },
        get columnSizing() {
          return a.columnSizing;
        },
        get columnFilters() {
          return a.columnFilters;
        },
        get expanded() {
          return a.expanded;
        },
        get columnVisibility() {
          return a.columnVisibility;
        },
        get rowSelection() {
          return a.rowSelection;
        },
        get columnPinning() {
          return a.columnPinning;
        },
        get columnOrder() {
          return a.columnOrder;
        },
        get rowPinning() {
          return a.rowPinning;
        }
      },
      autoResetPageIndex: !1,
      /* COLUMNS */
      get columns() {
        return oi(e);
      },
      /* DEFAULT COLUMNS */
      defaultColumn: {
        size: ((u = e.config.columnSizing) == null ? void 0 : u.size) ?? 150,
        minSize: ((v = e.config.columnSizing) == null ? void 0 : v.minSize) ?? 50,
        maxSize: ((p = e.config.columnSizing) == null ? void 0 : p.size) ?? 9999
      },
      /* HIDING */
      enableHiding: e.config.enableHiding ?? !0,
      /* SELECTION */
      enableRowSelection: e.config.enableSelection ?? !1,
      enableSubRowSelection: e.config.enableSelection ?? !1,
      enableMultiRowSelection: e.config.enableSelection ?? !1,
      onRowSelectionChange(d) {
        const m = Q(U(a.rowSelection));
        a.rowSelection = ne(d, m);
      },
      /* EXPANDED */
      enableExpanding: e.config.enableExpanding ?? !1,
      // paginateExpandedRows: true,
      // manualExpanding: false,
      getSubRows: (d, m) => {
        const { getRowId: x, getSubRows: w, getHasDetailRow: R } = e.config, y = [...(w == null ? void 0 : w(d, m)) ?? []];
        if (!ke(d) && (R != null && R(d, m))) {
          const O = Q(U(d));
          O[qe] = ci(x(O)), y.unshift(O);
        }
        return y;
      },
      getRowCanExpand: (d) => {
        const { getRowCanExpand: m, getHasDetailRow: x } = e.config;
        return ke(d.original) ? !1 : ((x == null ? void 0 : x(d.original, d.index)) || (m == null ? void 0 : m(d.original, d.index))) ?? !1;
      },
      onExpandedChange: (d) => {
        const m = $e(a.expanded) ? Q(U(a.expanded)) : a.expanded, x = ne(d, m);
        a.expanded = x, i.onExpandedChange(x, m);
      },
      /* Ordering */
      onColumnOrderChange: (d) => {
        const m = $e(a.columnOrder) ? Q(U(a.columnOrder)) : a.columnOrder, x = ne(d, m);
        a.columnOrder = x;
      },
      /* PAGINATION */
      manualPagination: !0,
      get pageCount() {
        return a.pagination.pageCount;
      },
      onPaginationChange: (d) => {
        const m = Q(U(a.pagination)), x = ne(d, m);
        a.pagination = x, i.onPaginationChange(x, m);
      },
      /* SORTING */
      manualSorting: !0,
      enableMultiSort: e.config.enableMultiSort ?? !1,
      onSortingChange: (d) => {
        const m = Q(U(a.sorting)), x = ne(d, m);
        a.sorting = x, i.onSortingChange(x, m);
      },
      /* PINNING */
      enablePinning: e.config.enablePinning ?? !1,
      onColumnPinningChange: (d) => {
        const m = Q(U(a.columnPinning)), x = ne(d, m);
        a.columnPinning = x;
      },
      /* COLUMN RESIZING */
      enableColumnResizing: !0,
      columnResizeMode: "onChange",
      onColumnSizingChange: (d) => {
        a.columnSizing = ne(d, a.columnSizing);
      },
      onColumnSizingInfoChange: (d) => {
        a.columnSizingInfo = ne(d, a.columnSizingInfo);
      },
      /* COLUMN VISIBILITY */
      onColumnVisibilityChange: (d) => {
        a.columnVisibility = ne(d, a.columnVisibility);
      },
      /* META */
      meta: {
        gridApi: e,
        headerRowRender: (d) => {
          const m = K(e.componentsPool.vgHeaderRow);
          return Z(m.component, { ...d, ...(m == null ? void 0 : m.props) ?? {} });
        },
        bodyRowRender: (d) => {
          const m = K(e.componentsPool.vgBodyRow);
          return Z(m.component, { ...d, ...(m == null ? void 0 : m.props) ?? {} });
        },
        bodySubRowRender: (d) => {
          const m = K(e.componentsPool.vgBodyRowSub);
          return Z(m.component, { ...d, ...(m == null ? void 0 : m.props) ?? {} });
        },
        bodyDetailRowRender: (d) => {
          const m = K(e.componentsPool.vgBodyRowDetail);
          return Z(m.component, { ...d, ...(m == null ? void 0 : m.props) ?? {} });
        }
      },
      /* GET ROW ID */
      getRowId: (d) => {
        const { getRowId: m } = e.config;
        return pi(d) ?? m(d);
      },
      /* MODELS */
      getCoreRowModel: wn(),
      getSortedRowModel: yn(),
      getPaginationRowModel: _n(),
      getFilteredRowModel: bn(),
      getExpandedRowModel: hn()
      /* OTHERS */
      // debugRows: true,
      // debugAll: import.meta.env.DEV
    }),
    state: a
  };
}
function ai() {
  const i = an(), e = rn();
  return {
    clipboard: i,
    memory: e.memory
  };
}
var Bt = (i, e, t) => {
  if (!e.has(i))
    throw TypeError("Cannot " + t);
}, ie = (i, e, t) => (Bt(i, e, "read from private field"), t ? t.call(i) : e.get(i)), Ze = (i, e, t) => {
  if (e.has(i))
    throw TypeError("Cannot add the same private member more than once");
  e instanceof WeakSet ? e.add(i) : e.set(i, t);
}, Xe = (i, e, t) => (Bt(i, e, "access private method"), t), te, ye, ze;
class Nt {
  constructor() {
    Ze(this, ye), Ze(this, te, /* @__PURE__ */ new Map());
  }
  on(e, t) {
    Xe(this, ye, ze).call(this, e, t, { once: !1 });
  }
  once(e, t) {
    Xe(this, ye, ze).call(this, e, t, { once: !0 });
  }
  emit(e, ...t) {
    if (!ie(this, te).has(e))
      return;
    const n = ie(this, te).get(e);
    for (const o of Array.from(n.values())) {
      const { ctx: r, handler: a } = o;
      a(...Array.from(t)), r.once && this.off(e, a);
    }
  }
  off(e, t) {
    if (ie(this, te).has(e))
      if (t) {
        const n = ie(this, te).get(e);
        n.delete(t), n.size === 0 ? ie(this, te).delete(e) : ie(this, te).set(e, n);
      } else
        ie(this, te).delete(e);
  }
}
te = /* @__PURE__ */ new WeakMap(), ye = /* @__PURE__ */ new WeakSet(), ze = function(i, e, t) {
  const n = ie(this, te).get(i) ?? /* @__PURE__ */ new Map();
  n.has(e) || (n.set(
    e,
    {
      handler: e,
      ctx: t
    }
  ), ie(this, te).set(i, n));
};
const we = {
  sortingChange: "gridApi::sortingChange",
  paginationChange: "gridApi::paginationChange",
  wipeFilters: "gridApi::wipeFilters",
  rowRenderCallbackTrigger: "gridApi::rerender"
}, Ce = new Nt();
var ce, Ut, Ht;
const me = class me {
  constructor({ baseKey: e, storage: t }) {
    je(this, ce);
    $(this, "baseKey");
    $(this, "storage");
    this.baseKey = e, this.storage = t;
  }
  bindKey(e, t) {
    return typeof window > "u" ? z(t) : sn(Re(this, ce, Ut).call(this, e), t, this.storage, {
      mergeDefaults: Re(this, ce, Ht)
    });
  }
};
ce = new WeakSet(), Ut = function(e) {
  return this.baseKey ? `${me.PREFIX}__${this.baseKey}__${e}` : `${me.PREFIX}__${e}`;
}, Ht = function(e, t) {
  return pn(e) && gn(e) ? vt({}, t, e) : e ?? t;
}, $(me, "PREFIX", "vg-grid");
let Me = me;
function re(i) {
  return JSON.parse(JSON.stringify(i));
}
class ri {
  constructor(e, t) {
    $(this, "gridApi");
    $(this, "storageController");
    $(this, "filterState");
    $(this, "relationStateInternal");
    this.gridApi = e, this.storageController = t, this.filterState = this.storageController.bindKey("columnFilters", e.datasource.columnFiltersState), this.relationStateInternal = z([]), this.gridApi.config.onFiltersInitialized && this.gridApi.config.onFiltersInitialized(this, this.gridApi);
  }
  /**
   * Get the filter value for a column
   * @param columnId The column id
   * @returns The filter value object or null if the column is not filtered
   */
  getColumnFilter(e) {
    const t = this.filterState.value.find((n) => n.id === e);
    return t ? t.value : null;
  }
  /**
   * Get the filter value for a column that can be written to
   * @param columnId The column id
   * @param index The index of the value
   * @returns The filter value or null if the column is not filtered
   */
  getColumnFilterWriteableData(e, t) {
    return f({
      get: () => {
        const n = this.filterState.value.find((o) => o.id === e);
        return n ? n.value.data[t] : null;
      },
      set: (n) => {
        this.setFilterOutput(e, n, t);
      }
    });
  }
  /**
   * Get the filter relation for a column that can be written to
   * @param columnId The column id
   * @param index The index of the value
   * @returns The filter relation or null if the column is not filtered
   */
  getColumnFilterWriteableRelation(e, t) {
    return f({
      get: () => {
        var a;
        const n = this.filterState.value.find((s) => s.id === e);
        if (n)
          return n.value.relation[t];
        const o = this.relationStateInternal.value.find((s) => s.id === e);
        return o ? o.relation[t] : ee(((a = this.gridApi.getColumnDefinitionById(e)) == null ? void 0 : a.relationOverride) ?? []);
      },
      set: (n) => {
        this.setFilterRelation(e, n, t);
      }
    });
  }
  /**
   * Check if column filter was enabled in the column definition
   * @param columnId The column id
   * @returns True if column filter is enabled
   */
  isColumnFilterEnabled(e) {
    const t = this.gridApi.getColumnDefinitionById(e);
    return (t == null ? void 0 : t.enableColumnFilter) ?? !1;
  }
  /**
   * Get the index of a column in the filter state
   * @param columnId The column id
   * @returns The index of the column in the filter state or -1 if the column is not filtered
   */
  filteredIndex(e) {
    return this.filterState.value.findIndex((t) => t.id === e);
  }
  /**
   * Check if a column is filtered
   * @param columnId The column id
   * @returns True if the column is filtered
   */
  isColumnFiltered(e) {
    return this.filterState.value.some((t) => t.id === e);
  }
  /**
   * Set the filter value for a column
   * @param columnId The column id
   * @param outputs The filter values
   * @param relations The relation values
   * @param triggerCallback Trigger fetch for new data
   */
  async setFilter(e, t, n, o = !0) {
    const r = {
      data: re(t),
      relation: re(n)
    };
    Array.isArray(r.data[0]) && r.data[0].length === 0 && (r.data[0] = null), Array.isArray(r.data[1]) && r.data[1].length === 0 && (r.data[1] = null);
    const a = this.filteredIndex(e);
    // Check if data is not the same as what we already have
    a !== -1 && JSON.stringify(this.filterState.value[a].value) === JSON.stringify(r) || a === -1 && r.data[0] === null && r.data[1] === null || (r.data[0] === null && r.data[1] === null ? a !== -1 && await this.clearFilter(e, !1) : a !== -1 ? this.filterState.value[a].value = r : this.filterState.value.push({
      id: e,
      value: r
    }), o && await this.onFilterChange());
  }
  /**
   * Set the filter value for a column
   * @param columnId The column id
   * @param value The filter value
   * @param index The index of the value
   * @param triggerCallback Trigger fetch for new data
   */
  async setFilterOutput(e, t, n, o = !0) {
    const r = this.filterState.value.find((s) => s.id === e), a = this.gridApi.getColumnDefinitionById(e);
    if (r) {
      const s = re(r.value.data);
      s[n] = t, await this.setFilter(e, s, r.value.relation, o);
    } else {
      const s = [null, null], u = [
        ee((a == null ? void 0 : a.relationOverride) ?? []),
        ee((a == null ? void 0 : a.relationOverride) ?? [])
      ];
      s[n] = t, await this.setFilter(e, s, u, o);
    }
  }
  /**
   * Set the filter relation for a column
   * @param columnId The column id
   * @param value The filter relation
   * @param index The index of the value
   * @param triggerCallback Trigger fetch for new data
   */
  async setFilterRelation(e, t, n, o = !0) {
    var v;
    const r = this.filterState.value.find((p) => p.id === e);
    if (r) {
      const p = re(r.value.relation);
      p[n] = t, await this.setFilter(e, U(r.value.data), p, o);
      return;
    }
    const a = this.relationStateInternal.value.find((p) => p.id === e);
    if (a) {
      a.relation[n] = t;
      const p = ee(((v = this.gridApi.getColumnDefinitionById(e)) == null ? void 0 : v.relationOverride) ?? []);
      JSON.stringify(a.relation) === JSON.stringify([p, p]) && (this.relationStateInternal.value = this.relationStateInternal.value.filter(
        (d) => d.id !== e
      ));
      return;
    }
    const s = this.gridApi.getColumnDefinitionById(e), u = [
      ee((s == null ? void 0 : s.relationOverride) ?? []),
      ee((s == null ? void 0 : s.relationOverride) ?? [])
    ];
    u[n] = t, this.relationStateInternal.value.push({
      id: e,
      relation: u
    });
  }
  /**
   * Clear the filter for a specific column
   * @param columnId The column id
   * @param triggerCallback Trigger fetch for new data
   */
  async clearFilter(e, t = !0) {
    this.filterState.value = this.filterState.value.filter((n) => n.id !== e), this.relationStateInternal.value = this.relationStateInternal.value.filter((n) => n.id !== e), t && await this.onFilterChange();
  }
  /**
   * Reset all filters to unfiltered state
   * @param triggerCallback Trigger fetch for new data
   */
  async resetFilters(e = !0) {
    this.filterState.value = [], this.relationStateInternal.value = [], e && await this.onFilterChange();
  }
  /**
   * Handle filter change event
   */
  async onFilterChange() {
    this.gridApi.tableState.value.pagination.pageIndex = 0, await this.gridApi.fetchData();
  }
}
function Ye(i, e) {
  const t = e.split(".");
  let n = i;
  for (const o of t)
    if (typeof n == "object" && n !== null && o in n)
      n = n[o];
    else {
      console.warn(`Key '${o}' not found in ${n}, cannot get value`);
      return;
    }
  return n;
}
function Qe(i, e, t, n = !0) {
  const o = e.split(".");
  let r = i;
  for (let s = 0; s < o.length - 1; s++) {
    const u = o[s];
    if (typeof r == "object" && r !== null && u in r)
      !n && r[u] === null && (r[u] = {}), r = r[u];
    else
      throw new Error("Key not found, cannot update");
  }
  const a = o[o.length - 1];
  if (typeof r == "object" && r !== null)
    return r[a] = t, !0;
  throw new Error("Key not found, cannot update");
}
class si {
  constructor(e) {
    $(this, "gridApi");
    $(this, "invalidCells", z([]));
    this.gridApi = e;
  }
  /**
   * Insert, update or remove a row from the InvalidCells array
   *
   * @param rowID The row ID
   * @param columnID The column ID
   * @param data The data to insert or update, if undefined the row will be removed
   */
  updateInvalidCellsData(e, t, n) {
    const o = this.invalidCells.value.findIndex((r) => r.rowID === e && r.columnID === t);
    n !== void 0 ? o === -1 ? this.invalidCells.value.push(n) : this.invalidCells.value[o] = n : o !== -1 && this.invalidCells.value.splice(o, 1);
  }
  /**
   * Validate a cell in the grid
   *
   * @param rowID The row ID
   * @param columnID The column ID
   * @param value The value to validate
   * @param validationRules The validation rules to apply
   */
  validateCell(e, t, n, o, r) {
    if (r && r.length) {
      let a;
      for (const s of r)
        if (a = s(n, o, this.gridApi), a !== void 0 && a !== !0)
          break;
      if (typeof a == "string")
        return this.updateInvalidCellsData(e, t, {
          rowID: e,
          columnID: t,
          message: a
        }), !1;
      if (a === !1)
        return this.updateInvalidCellsData(e, t, {
          rowID: e,
          columnID: t
        }), !1;
      this.updateInvalidCellsData(e, t);
    }
    return !0;
  }
  /**
   * Validate a cell or a row in the grid based on the configuration of the grid
   *
   * @param rowID The row ID
   * @param columnID The column ID
   * @param value The value to validate
   * @param data The supplementary row data
   * @param validationRules The validation rules to apply
   */
  validate(e, t, n, o, r) {
    const a = vt(
      JSON.parse(JSON.stringify(o)),
      JSON.parse(
        JSON.stringify(this.gridApi.updatedData.find((s) => s.id === e) ?? {})
      )
    );
    if (a === void 0)
      throw new Error(
        "Row data not found inside updatedData during validation, something must have gone terribly wrong"
      );
    return this.gridApi.config.validationMode === "row" ? this.validateRow(e, a) : this.validateCell(e, t, n, a, r);
  }
  /**
   * Validate a row in the grid
   *
   * @param rowId The row ID
   * @param data The data to validate
   */
  validateRow(e, t) {
    var r;
    const n = this.gridApi.table.value.getRow(e);
    let o = !0;
    for (const a of n.getAllCells())
      o = o && this.validateCell(
        e,
        a.column.id,
        a.getValue(),
        t,
        (r = this.gridApi.getColumnDefinitionById(a.column.id)) == null ? void 0 : r.validationRules
      );
    return o;
  }
  /**
   * Validate all cells in the grid
   */
  validateAll() {
    var t;
    const e = this.gridApi.table.value.getRowModel().flatRows;
    for (const n of e)
      for (const o of n.getAllCells())
        this.validate(
          o.row.id,
          o.column.id,
          o.getValue(),
          o.row.original,
          (t = this.gridApi.getColumnDefinitionById(o.column.id)) == null ? void 0 : t.validationRules
        );
  }
  /**
   * Get the invalid cell data, returns undefined if the cell is not marked as invalid
   */
  getInvalidCellData(e, t) {
    return f(() => this.invalidCells.value.find((n) => n.rowID === e && n.columnID === t));
  }
  /**
   * Check if the cell is marked as invalid
   */
  isCellInvalid(e, t) {
    return f(() => this.invalidCells.value.some((n) => n.rowID === e && n.columnID === t));
  }
  /**
   * Check if the row has any invalid cells
   */
  isRowInvalid(e) {
    return f(() => this.invalidCells.value.some((t) => t.rowID === e));
  }
  /**
   * Check if the column has any invalid cells
   */
  isColumnInvalid(e) {
    return f(() => this.invalidCells.value.some((t) => t.columnID === e));
  }
  /**
   * Wipe all invalid cells, resetting the invalidCells array
   */
  resetValidation() {
    this.invalidCells.value = [];
  }
  /**
   * Remove a row from the invalidCells array
   * Should be called when a row is removed from the grid
   */
  removeRowFromInvalid(e) {
    this.invalidCells.value = this.invalidCells.value.filter((t) => t.rowID !== e);
  }
}
class et extends Error {
}
class da extends Nt {
  constructor(t) {
    var n;
    super();
    $(this, "tableState", z(null));
    $(this, "table", z(null));
    $(this, "extraOptions");
    $(this, "defaultExtraOptions");
    $(this, "rootElement", z(null));
    $(this, "bodyElement", z(null));
    $(this, "i18n", z(null));
    $(this, "virtualScroller", z(null));
    $(this, "ready", !1);
    $(this, "selectedCellsApi");
    $(this, "utils");
    $(this, "config");
    $(this, "state");
    $(this, "validation");
    $(this, "options");
    $(this, "datasource");
    $(this, "componentsPool");
    $(this, "storageController");
    $(this, "fetchMoreDataDebounced");
    $(this, "editing");
    $(this, "updatedData");
    $(this, "subgridsUpdatedData");
    $(this, "areSubgridsUpdated");
    $(this, "infinityScrollOffset", 0);
    $(this, "blockFutherInfinityScrollFetch", z(!1));
    $(this, "clickedRow", z(null));
    $(this, "id");
    $(this, "subgrids");
    $(this, "parentGrid");
    $(this, "localeUnwatch");
    $(this, "stateUnwatch");
    $(this, "suppressStateChangeCallback");
    $(this, "filters");
    this.config = t.config, this.validation = new si(this), this.id = t.id, this.subgrids = Yt(/* @__PURE__ */ new Map()), this.parentGrid = t.parentGrid ?? null, this.utils = ai(), this.selectedCellsApi = ii(this), this.options = t, this.editing = z(!1), this.clickedRow = z(null), this.datasource = Qn(this.config.datasource), this.componentsPool = Yn(this.config.componentsPool), this.storageController = new Me({
      baseKey: ((n = this.config.storage) == null ? void 0 : n.baseKey) ?? t.id,
      storage: this.options.storage
    }), this.filters = new ri(this, this.storageController), this.defaultExtraOptions = {
      accessibility: {
        fontWeight: "inherit",
        fontSize: "13px",
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif',
        rowHeightMultiplier: 1,
        gridContentHeight: 70
      },
      fullscreen: !1,
      filtersVisible: !1,
      extraFiltersVisible: !1,
      extraFiltersColumnNumber: 4,
      enableDetailDrawer: !1,
      dragAndDrop: !1
    }, this.extraOptions = this.storageController.bindKey("extraOptions", {
      ...this.defaultExtraOptions,
      ...this.config.extraOptions
    }), this.fetchMoreDataDebounced = fn(() => void this.fetchMoreData(), 350), this.state = he({
      data: [],
      selectableCells: f(() => (this.config.enableCellSelection ?? !1) && !this.editing.value),
      loaderVisible: !1,
      totalRowCount: void 0
    }), this.updatedData = he([]), this.subgridsUpdatedData = f(() => Array.from(this.subgrids.values()).map((o) => o.updatedData).filter((o) => o.length > 0)), this.areSubgridsUpdated = f(() => this.subgridsUpdatedData.value.length > 0), this.localeUnwatch = null, this.suppressStateChangeCallback = z(!1), this.stateUnwatch = de([this.state, this.extraOptions], () => {
      this.config.onStateChange && !this.suppressStateChangeCallback.value && this.config.onStateChange({
        gridApi: this,
        state: this.state,
        extraOptions: this.extraOptions.value
      });
    });
  }
  /**
   * Create the Tanstack table and its state
   */
  createTable() {
    return li({
      gridApi: this,
      onSortingChange: () => {
        this.onSortingChangeInternal();
      },
      onPaginationChange: (t, n) => {
        this.onPaginationChangeInternal(t, n);
      },
      onColumnFiltersChange: () => {
        this.onColumnFiltersChangeInternal();
      },
      onExpandedChange: () => {
      }
    });
  }
  /**
   * Prepare the grid for mounting
   */
  onBeforeMount() {
    if (this.tableState.value === null) {
      const { table: t, state: n } = this.createTable();
      this.table.value = t, this.tableState.value = n;
    } else
      this.datasource.suppressGetRowsInitially = !0;
  }
  /**
   * Unmount the grid and destroy all subgrids
   */
  onBeforeUnmount() {
    if (this.parentGrid) {
      for (const t of this.subgrids.values())
        t.destroy();
      this.updatedData.length < 1 && this.subgrids.size < 1 ? this.parentGrid.subgrids.delete(this.id) : console.log(`Grid with id ${this.id} has unsaved changes or subgrids, storing in memory`);
    }
    this.rootElement.value = null, this.ready = !1;
  }
  /**
   * Mount the grid and fetch data
   */
  async onMounted() {
    var n, o;
    if (this.parentGrid) {
      if (this.parentGrid.subgrids.has(this.id)) {
        console.log(`Grid with id ${this.id} already exists in parent grid, assuming that we are being re-mounted`), this.ready = !0;
        return;
      }
      this.parentGrid.subgrids.set(this.id, this);
    }
    this.editing.value = this.config.startInEditMode ?? !1;
    const t = de(
      () => this.i18n.value,
      () => {
        this.rerender();
      },
      {
        deep: !0
      }
    );
    this.localeUnwatch = t, this.config.enableCellSelection && this.selectedCellsApi.init(), this.datasource.suppressGetRowsInitially || await this.fetchData(), this.ready = !0, (o = (n = this.config).onReady) == null || o.call(n, { gridApi: this });
  }
  /**
   * Destroy the grid and all of its subgrids
   */
  destroy() {
    var t, n, o;
    (t = this.localeUnwatch) == null || t.call(this), (o = (n = this.config).onDestroyed) == null || o.call(n, { gridApi: this }), this.selectedCellsApi.destroy();
  }
  onSortingChangeInternal() {
    this.tableState.value.pagination.pageIndex = 0, this.fetchData();
  }
  onColumnFiltersChangeInternal() {
    this.tableState.value.pagination.pageIndex = 0, this.fetchData();
  }
  onPaginationChangeInternal(t, n) {
    zn(t, n, { fields: ["pageIndex", "pageSize"] }) || (t.pageSize !== n.pageSize && (this.tableState.value.pagination.pageIndex = 0), this.fetchData());
  }
  /**
   * Automatically sizes all columns to fit the available width of the grid (except special columns like the selection
   * column, etc.)
   *
   * @example
   * config: {
   *    onReady(({ gridApi }) => {
   *      gridApi.sizeColumnsToFit();
   *    });
   * }
   */
  sizeColumnsToFitFn(t = !1, n = 20) {
    if (!this.ready) {
      console.warn("Grid is not ready yet, skipping sizeColumnsToFit");
      return;
    }
    const o = Q(U(this.tableState.value.columnSizing));
    if (JSON.stringify(o) !== "{}" && !t)
      return;
    let r = 0;
    r += +(this.config.enableSelection ?? !1) * Et, r += +(this.config.enableExpanding ?? !1) * Mt, r += +(this.config.enableRowDragAndDrop ?? !1) * Tt, r += n;
    const a = this.rootElement.value.offsetWidth - r;
    if (a <= 0) {
      console.warn(
        `Width of grid=${this.id} is less than or equal to 0, skipping sizeColumnsToFit, this is likely due to the element being hidden or inside a tab/accordion/dropdown`
      );
      return;
    }
    console.debug("Resizing columns to fit width", a);
    const s = this.table.value.getVisibleLeafColumns().filter((p) => p.id.startsWith("vg-")), u = this.table.value.getVisibleLeafColumns(), v = Math.ceil(a / (u.length - s.length));
    u.forEach((p) => {
      const { minSize: d = 0, maxSize: m = Number.MAX_SAFE_INTEGER } = p.columnDef;
      p.id.startsWith("vg-") || (o[p.id] = v > m ? m : v < d ? d : v);
    }), this.table.value.setColumnSizing(o);
  }
  /**
   * Sizes all columns to the same width (except special columns like the selection column, etc.)
   *
   * @example
   * config: {
   *    onReady(({ gridApi }) => {
   *      gridApi.sizeColumnsStatic(200);
   *    });
   * }
   */
  sizeColumnsStatic(t, n = !1) {
    if (!this.ready)
      return;
    const o = Q(U(this.tableState.value.columnSizing));
    if (JSON.stringify(o) !== "{}" && !n)
      return;
    this.table.value.getVisibleLeafColumns().forEach((a) => {
      const { minSize: s = 0, maxSize: u = Number.MAX_SAFE_INTEGER } = a.columnDef;
      a.id.startsWith("vg-") || (o[a.id] = t > u ? u : t < s ? s : t);
    }), this.table.value.setColumnSizing(o);
  }
  /**
   * Sizes a column by its id.
   *
   * @example
   * config: {
   *    onReady(({ gridApi }) => {
   *      gridApi.sizeColumnsByColumnId('name', 200);
   *    });
   * }
   */
  sizeColumnsByColumnId(t, n, o = !1) {
    if (!this.ready)
      return;
    const r = Q(U(this.tableState.value.columnSizing));
    JSON.stringify(r) !== "{}" && !o || (r[t] = n, this.table.value.setColumnSizing(r));
  }
  /**
   * Overwrite the data of the grid
   */
  setData(t) {
    this.resetState(), this.state.data = t;
  }
  /**
   * Reset table to initial state
   */
  resetState() {
    this.validation.resetValidation(), this.table.value.resetRowSelection(), this.updatedData.splice(0, this.updatedData.length);
  }
  /**
   * Get the data of the grid
   */
  getVisibleCells() {
    const t = this.table.value, { rows: n } = t.getRowModel();
    return n.map((o) => o.getVisibleCells().filter((r) => !r.column.id.startsWith("vg-"))).flat();
  }
  /**
   * Copy the data of the grid to the clipboard
   */
  async copyDataToClipboard() {
    var n;
    let t = "";
    return typeof ((n = this.options.config.copyToClipboardConfig) == null ? void 0 : n.getClipboardContent) == "function" ? t = await this.options.config.copyToClipboardConfig.getClipboardContent(this.getVisibleCells(), this) : t = Ot(
      di(this, (o) => Pe(o))
    ), this.utils.clipboard.copy(t);
  }
  /**
   * Show the internal loader of the grid
   */
  showLoader() {
    this.state.loaderVisible = !0;
  }
  /**
   * Hide the internal loader of the grid
   */
  hideLoader() {
    this.state.loaderVisible = !1;
  }
  /**
   * Returns the selected rows of the grid
   */
  get selectedRows() {
    return f(() => {
      var t;
      return ((t = this.table.value) == null ? void 0 : t.getSelectedRowModel().flatRows) ?? [];
    });
  }
  /**
   * Returns the global context of the grid
   */
  getCtx() {
    return {
      gridApi: this,
      i18n: this.i18n.value,
      id: this.options.id
    };
  }
  /**
   * Use this with attention!
   * @private
   */
  rerender() {
    this.state.data = this.state.data.slice(), Ce.emit(we.rowRenderCallbackTrigger);
  }
  /**
   * Fetch fresh data from the server, overwriting the current data
   */
  async fetchData() {
    var t;
    this.showLoader(), this.infinityScrollOffset = 0, this.blockFutherInfinityScrollFetch.value = !1;
    try {
      const n = await this.datasource.getData({
        gridApi: this,
        pagination: U(this.tableState.value.pagination),
        sorting: U(this.tableState.value.sorting),
        columnFilters: re(this.filters.filterState.value)
      });
      this.tableState.value.pagination.pageCount = n.pageCount, this.config.enableInfinityScroll && (this.tableState.value.pagination.pageSize = ((t = this.config.datasource.paginationState) == null ? void 0 : t.pageSize) ?? 10), this.resetState(), this.state.data = n.data, this.state.totalRowCount = n.totalRowCount, this.hideLoader();
    } catch (n) {
      this.hideLoader(), console.error(n);
    }
    Ce.emit(we.rowRenderCallbackTrigger), await Ie(() => {
      var n, o;
      return (o = (n = this.config).onAfterFetch) == null ? void 0 : o.call(n, { gridApi: this });
    });
  }
  /**
   * Fetch more data for the grid with infinity scroll enabled and append it to the existing data
   */
  async fetchMoreData() {
    var t;
    if (!this.blockFutherInfinityScrollFetch.value) {
      this.showLoader(), this.infinityScrollOffset += 1;
      try {
        const n = await this.datasource.getData({
          gridApi: this,
          pagination: {
            pageIndex: this.infinityScrollOffset,
            pageSize: ((t = this.config.datasource.paginationState) == null ? void 0 : t.pageSize) ?? 10
          },
          sorting: U(this.tableState.value.sorting),
          columnFilters: re(this.filters.filterState.value)
        });
        if (this.tableState.value.pagination.pageCount = n.pageCount, n.data.length < 1) throw new et("No more data to fetch");
        const o = U(this.state.data);
        o.push(...n.data), this.state.data = o, this.state.totalRowCount = n.totalRowCount, this.hideLoader(), this.rerender();
      } catch (n) {
        this.blockFutherInfinityScrollFetch.value = !0, this.hideLoader(), n instanceof et ? console.info(n.message) : console.error(n);
      }
      Ce.emit(we.rowRenderCallbackTrigger), await Ie(() => {
        var n, o;
        return (o = (n = this.config).onAfterFetchMore) == null ? void 0 : o.call(n, { gridApi: this });
      });
    }
  }
  /**
   * Update the edited data in the grid
   *
   * Automatically removes the row from the updatedData array if the data is the same as the original
   *
   * @example
   * setUpdatedData('name', 'row_id_1', 'John');
   */
  setUpdatedData(t, n, o) {
    const r = this.getColumnDefinitionById(t).valueGetter;
    if (typeof r != "string")
      throw new Error(`Only string getters are supported, received ${typeof r}`);
    const a = this.config.getRowId, s = (p, d) => {
      var w, R;
      if (a(d) === p)
        return d;
      const m = this.table.value.getRow(p), x = (R = (w = this.config).getSubRows) == null ? void 0 : R.call(w, d, m.index);
      if (x !== void 0)
        for (const y of x) {
          if (a(y) === p)
            return y;
          const O = s(p, y);
          if (O)
            return O;
        }
    }, u = (p) => {
      for (const d of this.state.data) {
        const m = s(p, d);
        if (m)
          return m;
      }
    }, v = this.updatedData.findIndex((p) => a(p) === n);
    if (v === -1) {
      let p = this.state.data.find((d) => a(d) === n);
      if (!p && this.config.getSubRows && (p = u(n)), !p) {
        console.warn(`Row with id ${n} not found`);
        return;
      }
      if (JSON.stringify(Ye(p, r)) !== JSON.stringify(o)) {
        const d = JSON.parse(JSON.stringify(p));
        Qe(d, r, o, this.config.strictEditMode ?? !0), this.updatedData.push(d);
      }
    } else {
      Qe(this.updatedData[v], r, o, this.config.strictEditMode ?? !0);
      const p = u(n), d = this.updatedData.find((m) => a(m) === n);
      JSON.stringify(p) === JSON.stringify(d) && this.updatedData.splice(v, 1);
    }
  }
  /**
   * Get updated value from the updatedData array
   *
   * @example
   * const updatedValue = getUpdatedData('name', 'row_id_1');
   */
  getUpdatedData(t, n) {
    return f(() => {
      var a;
      const o = this.config.getRowId, r = this.updatedData.findIndex((s) => o(s) === n);
      if (r !== -1) {
        const s = (a = this.getColumnDefinitionById(t)) == null ? void 0 : a.valueGetter;
        if (typeof s != "string")
          throw new Error(`Only string getters are supported, received ${typeof s}`);
        return Ye(this.updatedData[r], s);
      }
    });
  }
  /**
   * Wipe all updated data for this grid
   */
  wipeUpdatedData() {
    this.updatedData.splice(0, this.updatedData.length);
  }
  /**
   * Wipe all updated data for this grid and all of its subgrids recursively
   */
  wipeUpdatedDataRecursively() {
    this.wipeUpdatedData();
    for (const t of this.subgrids.values())
      t.wipeUpdatedDataRecursively();
  }
  /**
   * Remove a row from the updatedData array
   */
  removeFromUpdatedData(t) {
    const n = this.config.getRowId, o = this.updatedData.findIndex((r) => n(r) === t);
    o !== -1 && this.updatedData.splice(o, 1);
  }
  get hasUnsavedChanges() {
    return this.updatedData.length > 0;
  }
  async saveChanges(t = !1) {
    var s, u;
    const n = Q(this.updatedData), r = (await Promise.all(
      Array.from(this.subgrids.values()).map((v) => v.saveChanges(!0))
    )).filter((v) => v !== void 0), a = {
      grid: this,
      data: n,
      subgrids: r
    };
    if (t)
      return a;
    try {
      await ((u = (s = this.config).saveCallback) == null ? void 0 : u.call(s, a)), this.config.refreshAfterSave && (this.resetState(), await this.fetchData());
    } catch (v) {
      console.error(v), this.config.saveFailedCallback && await this.config.saveFailedCallback(a);
    }
  }
  /**
   * Moves a column from one position to another.
   *
   * @example
   * moveColumn('name', 'age');
   */
  moveColumn(t, n) {
    const r = this.table.value.getAllLeafColumns().map((v) => v.id), a = r.indexOf(t), s = r.indexOf(n), u = r.slice();
    u.splice(a, 1), u.splice(s, 0, t), this.table.value.setColumnOrder(u);
  }
  /**
   * Updates a row in the grid with the provided data.
   * This can be partial data, as we use Object.assign to merge the data internally.
   *
   * @example
   * const data = { name: 'John', age: 30 };
   * updateRow(0, data);
   */
  updateRow(t, n) {
    const o = this.state.data.find((a) => this.config.getRowId(a) === t);
    o ? Object.assign(o, n) : console.warn(`Row with id '${t}' not found`);
    const r = this.config.getRowId(o);
    r !== t && (this.rerender(), this.removeFromUpdatedData(t), console.warn(
      `Row with ID '${t}' had ID updated to '${r}', rerendering and removing from updated data`
    ));
  }
  /**
   * Returns the column definition by its id (recursively searches nested columns)
   *
   * @example
   * const columnDefinition = getColumnById('name');
   */
  getColumnDefinitionById(t, n = this.config.columns) {
    for (const o of n) {
      if (o.id === t)
        return o;
      if (o.columns) {
        const r = this.getColumnDefinitionById(t, o.columns);
        if (r)
          return r;
      }
    }
  }
  hasColumnChildren(t) {
    var o;
    const n = this.getColumnDefinitionById(t);
    if (!n)
      throw new Error(`Column with id ${t} not found`);
    return (((o = n.columns) == null ? void 0 : o.length) ?? 0) > 0;
  }
  /**
   * Add a new user created row to the grid
   *
   * @example
   * createNewRowFromTemplate();
   */
  createNewRowFromTemplate() {
    const t = typeof this.config.rowCreationDefaults == "function" ? this.config.rowCreationDefaults(this) : this.config.rowCreationDefaults, n = re(t ?? {}), o = "vg-new-row-" + Math.random().toString(36).substring(2, 9);
    if (this.config.setRowId)
      this.config.setRowId(n, o);
    else
      throw new Error("config.setRowId is not defined");
    this.config.createdRowsLocation === "bottom" ? this.state.data = this.state.data.concat([n]) : this.state.data = [n].concat(this.state.data);
  }
  /**
   * Remove a row from the grid, does not fail if the row is not found
   *
   * @param rowId - The id of the row to remove
   *
   * @example
   * removeRow('row_id_1');
   */
  removeRow(t) {
    this.state.data = this.state.data.filter((n) => this.config.getRowId(n) !== t), this.validation.removeRowFromInvalid(t), this.removeFromUpdatedData(t);
  }
  /**
   * Fire a callback to export the data in a specific format
   */
  async export(t) {
    var n;
    this.showLoader();
    try {
      if (!((n = this.config.export) != null && n.onExport))
        throw new Error("onExport callback is not defined");
      await this.config.export.onExport({
        format: t,
        gridApi: this,
        pagination: U(this.tableState.value.pagination),
        sorting: U(this.tableState.value.sorting),
        columnFilters: U(this.filters.filterState.value)
      }), this.hideLoader();
    } catch (o) {
      this.hideLoader(), console.error(o);
    }
  }
  /**
   * Load state and extra options from object
   */
  loadState(t) {
    this.suppressStateChangeCallback.value = !0, this.tableState.value = t.state, this.extraOptions.value = t.extraOptions, this.suppressStateChangeCallback.value = !1;
  }
}
function tt(i, e, t) {
  return ve(i.editable) ? i.editable({
    data: e.row.original,
    gridApi: t
  }) : i.editable !== !1;
}
function ge(i, e) {
  var t;
  return {
    id: i.id,
    enableSorting: i.enableSorting ?? !1,
    enableMultiSort: i.enableMultiSort ?? !0,
    enableColumnFilter: i.enableColumnFilter ?? !1,
    enableHiding: i.enableHiding ?? !0,
    enableGlobalFilter: !1,
    enableGrouping: !1,
    enableResizing: i.enableResizing ?? !0,
    enablePinning: i.enablePinning ?? !0,
    filterFn: "equals",
    columns: (t = i.columns) == null ? void 0 : t.map((n) => ge(n, e)),
    size: i.size,
    maxSize: i.maxSize,
    minSize: i.minSize,
    meta: {
      gridApi: e,
      filterCustomData: i.columnFilterCustomData ?? {},
      valueFormatter: i.valueFormatter,
      columnDef: i
    },
    header: (n) => Z(i.header ?? Mo, En(n)),
    cell: (n) => {
      let o;
      return e.editing.value && e.config.enableEditing === !0 && tt(i, n, e) && !ve(i.valueGetter) ? o = "edit" : e.config.enableEditing === "inline" && tt(i, n, e) && !ve(i.valueGetter) ? o = "inlineEdit" : o = "normal", {
        normal: () => Z(Tn(i.columnType, e, i.cell), Oe(n)),
        edit: () => Z(Ji, Oe(n)),
        targetMode: o
      };
    },
    sortDescFirst: (i.preferredSortingDirection ?? "desc") === "desc",
    footer: void 0,
    accessorFn: (n, o) => {
      if (At(i.valueGetter))
        return Se(n, i.valueGetter, void 0);
      if (ve(i.valueGetter))
        return i.valueGetter({
          data: n,
          rowIndex: o,
          columnDef: i
        });
    }
  };
}
const ui = (i) => i.getValue();
function di(i, e = ui) {
  var r, a;
  const t = He(i.getVisibleCells(), (s) => s.row.id), n = Object.values(t).map((s) => s.map((u) => e(u)));
  return ((r = i.config.copyToClipboardConfig) == null ? void 0 : r.includeHeaders) === !1 ? n : [((a = i.table.value) == null ? void 0 : a.getVisibleLeafColumns().filter((s) => !s.id.startsWith("vg-")).map((s) => {
    var v, p, d, m, x;
    const u = ((v = s.columnDef.meta) == null ? void 0 : v.columnDef.headerName) ?? s.columnDef.meta.columnDef.id;
    if (((p = i.config.copyToClipboardConfig) == null ? void 0 : p.includeGroupHeaders) !== !1) {
      const w = (d = s.parent) == null ? void 0 : d.id;
      if (w) {
        const R = i.getColumnDefinitionById(w);
        return (m = i.config.copyToClipboardConfig) != null && m.groupHeaderFormatter ? (x = i.config.copyToClipboardConfig) == null ? void 0 : x.groupHeaderFormatter((R == null ? void 0 : R.headerName) ?? "", u) : `${R == null ? void 0 : R.headerName} - ${u}`;
      }
    }
    return u;
  })) ?? [], ...n];
}
function _e(i) {
  return i.columnDef.meta;
}
function Gt(i) {
  return i.table.value.options.meta;
}
function ca(i) {
  const [, e = i] = zt.exec(i) ?? [];
  return e;
}
function ci(i) {
  return zt.test(i) ? i : `${i}__${Pt}`;
}
function ke(i) {
  return !!i[qe];
}
function pi(i) {
  return i[qe];
}
function K(i) {
  if (!i)
    return;
  let e, t = {};
  return "component" in i && i.component ? (e = i.component, t = i.props || {}) : e = i, {
    component: e,
    props: t
  };
}
function H() {
  return Be(kt);
}
const gi = { class: "vg-table-content-wrapper" }, fi = { class: "vg-table-content__prepend" }, vi = { class: "vg-table-header-wrapper" }, mi = { class: "vg-table-content__append" }, hi = {
  key: 2,
  class: "vg-infinity-scroll-footer-wrapper"
}, bi = {
  key: 0,
  class: "vg-pagination__section vg-pagination__section--total-row-count"
}, _i = /* @__PURE__ */ V({
  __name: "VgTable",
  setup(i) {
    Ne((G) => ({
      "4009b207": o.value,
      "1a2e3efa": R.value
    }));
    const { gridApi: e, i18n: t } = H(), n = f(() => [
      // Disable fullscreen if it's disabled in config so that users
      // are not stuck in fullscreen mode when developer disables it
      e.config.enableFullscreen !== !1 && e.extraOptions.value.fullscreen ? ["vg-table-main-wrapper", "vg-table-fullscreen"] : ["vg-table-main-wrapper"]
    ]), o = f(() => e.extraOptions.value.accessibility.fontWeight), r = f(() => K(e.componentsPool.topMenuPrepend)), a = f(() => K(e.componentsPool.topMenuDefault)), s = f(() => K(e.componentsPool.topMenuAppend)), u = f(
      () => K(e.componentsPool.topMenuToggleablePrepend)
    ), v = f(
      () => K(e.componentsPool.topMenuToggleableAppend)
    ), p = f(() => K(e.componentsPool.topMenuHeaderLeftSide)), d = f(() => K(e.componentsPool.topMenuHeaderRightSide)), m = f(
      () => K(e.componentsPool.vgInfinityScrollRowFooter)
    ), x = f(() => K(e.componentsPool.vgTablePrepend)), w = f(() => K(e.componentsPool.vgTableAppend)), R = f(() => {
      var T, C;
      const P = ((C = (T = e.extraOptions.value) == null ? void 0 : T.accessibility) == null ? void 0 : C.gridContentHeight) ?? 70;
      return e.config.enableGridResizeByUser ? P.toString() + "vh" : "100%";
    }), y = f(() => ({
      "vg-table-content": !0,
      "vg-table-is-fullscreen": e.extraOptions.value.fullscreen ?? !1
    })), O = f(() => ({
      "vg-table-body-wrapper": !0,
      "vg-table-body-wrapper--dynamic": e.config.enableDynamicRendering ?? !1
    }));
    return (G, P) => {
      var T, C, F, A, E, W;
      return c(), _("div", {
        class: X(n.value)
      }, [
        h("div", gi, [
          g(l(fo)),
          l(e).config.enableTopMenu ?? !0 ? (c(), k(l(Fi), { key: 0 }, {
            prepend: b(() => {
              var B, N;
              return [
                (c(), k(q((B = r.value) == null ? void 0 : B.component), L((N = r.value) == null ? void 0 : N.props, { gridApi: l(e) }), null, 16, ["gridApi"]))
              ];
            }),
            default: b(() => {
              var B, N;
              return [
                (c(), k(q((B = a.value) == null ? void 0 : B.component), L((N = a.value) == null ? void 0 : N.props, { gridApi: l(e) }), null, 16, ["gridApi"]))
              ];
            }),
            append: b(() => {
              var B, N;
              return [
                (c(), k(q((B = s.value) == null ? void 0 : B.component), L((N = s.value) == null ? void 0 : N.props, { gridApi: l(e) }), null, 16, ["gridApi"]))
              ];
            }),
            "toggleable-prepend": b(() => {
              var B, N;
              return [
                (c(), k(q((B = u.value) == null ? void 0 : B.component), L((N = u.value) == null ? void 0 : N.props, { gridApi: l(e) }), null, 16, ["gridApi"]))
              ];
            }),
            "toggleable-append": b(() => {
              var B, N;
              return [
                (c(), k(q((B = v.value) == null ? void 0 : B.component), L((N = v.value) == null ? void 0 : N.props, { gridApi: l(e) }), null, 16, ["gridApi"]))
              ];
            }),
            "header-left-side": b(() => {
              var B, N;
              return [
                (c(), k(q((B = p.value) == null ? void 0 : B.component), L((N = p.value) == null ? void 0 : N.props, { gridApi: l(e) }), null, 16, ["gridApi"]))
              ];
            }),
            "header-right-side": b(() => {
              var B, N;
              return [
                (c(), k(q((B = d.value) == null ? void 0 : B.component), L((N = d.value) == null ? void 0 : N.props, { gridApi: l(e) }), null, 16, ["gridApi"]))
              ];
            }),
            _: 1
          })) : M("", !0),
          h("div", fi, [
            (c(), k(q((T = x.value) == null ? void 0 : T.component), L((C = x.value) == null ? void 0 : C.props, { gridApi: l(e) }), null, 16, ["gridApi"]))
          ]),
          h("div", {
            class: X(y.value)
          }, [
            h("div", vi, [
              g(l(Ro))
            ]),
            h("div", {
              class: X(O.value)
            }, [
              g(l(Ui)),
              g(l(Fn), {
                loading: l(e).state.loaderVisible
              }, null, 8, ["loading"])
            ], 2)
          ], 2),
          h("div", mi, [
            (c(), k(q((F = w.value) == null ? void 0 : F.component), L((A = w.value) == null ? void 0 : A.props, { gridApi: l(e) }), null, 16, ["gridApi"]))
          ]),
          l(e).config.enablePagination !== !1 && l(e).config.enableInfinityScroll !== !0 ? (c(), k(l(Wl), { key: 1 }, {
            default: b(({ paginationProps: B }) => [
              g(l(Gl), Qt(en(B)), null, 16)
            ]),
            _: 1
          })) : l(e).config.enableInfinityScroll ? (c(), _("div", hi, [
            (c(), k(q((E = m.value) == null ? void 0 : E.component), L((W = m.value) == null ? void 0 : W.props, { gridApi: l(e) }), null, 16, ["gridApi"])),
            l(e).state.totalRowCount ? (c(), _("div", bi, [
              h("p", null, S(l(t).t("pagination.totalRowCount")) + ": " + S(l(e).state.totalRowCount), 1)
            ])) : M("", !0)
          ])) : M("", !0)
        ])
      ], 2);
    };
  }
});
function yi(i) {
  switch (i) {
    case "copy-to-clipboard":
      return cl;
    case "edit":
      return fl;
    case "save":
      return Ol;
    case "delete":
      return pl;
    case "clear-filter":
      return ol;
    case "refresh":
      return Al;
    case "accessibility":
      return il;
    case "fullscreen":
      return Dl;
    case "column-visibility":
      return dl;
    case "global-filters":
      return Rl;
    case "supress-detail-drawer":
      return vl;
    case "reset-settings":
      return $l;
    case "drag-and-drop":
      return gl;
    case "export":
      return _l;
  }
}
function wi() {
  return [
    "export",
    "drag-and-drop",
    "reset-settings",
    "copy-to-clipboard",
    "supress-detail-drawer",
    "global-filters",
    "column-visibility",
    "fullscreen",
    "accessibility"
  ];
}
function Ci() {
  return ["refresh", "clear-filter", "delete", "save", "edit"];
}
function xi() {
  return [];
}
const Si = { class: "vg-top-bar" }, Vi = { class: "vg-top-bar-content-wrapper" }, ki = { class: "vg-top-bar-content-left-side" }, Di = {
  key: 0,
  class: "vg-top-bar-header"
}, Ri = { class: "vg-top-bar-header-buttons" }, Ai = { class: "vg-top-bar-buttons" }, Ii = {
  key: 0,
  class: "vg-top-bar-buttons-visible-on-demand"
}, Fi = /* @__PURE__ */ V({
  __name: "VgTopMenu",
  setup(i) {
    const e = ae(), { gridApi: t } = H(), n = z(!1), o = (u, v) => f(() => {
      var m;
      const p = [], d = ((m = t.config.topMenuItems) == null ? void 0 : m[u]) ?? v();
      for (const x of d) {
        const w = yi(x);
        p.push(Z(w, { gridApi: t, i18n: e }));
      }
      return p;
    }), r = o("collapsible", wi), a = o("alwaysVisible", Ci), s = o(
      "alwaysVisibleHeader",
      xi
    );
    return (u, v) => {
      var p, d, m, x;
      return c(), _("div", Si, [
        h("div", Vi, [
          h("div", ki, [
            J(u.$slots, "header-left-side"),
            l(t).config.name ? (c(), _("div", Di, [
              h("h2", null, S(l(t).config.name), 1)
            ])) : M("", !0),
            J(u.$slots, "header-right-side"),
            h("div", Ri, [
              (c(!0), _(j, null, Y(l(s), (w, R) => (c(), k(q(w), { key: R }))), 128))
            ])
          ]),
          h("div", Ai, [
            J(u.$slots, "prepend"),
            n.value ? (c(), _("div", Ii, [
              J(u.$slots, "toggleable-prepend"),
              (c(!0), _(j, null, Y(l(r), (w, R) => (c(), k(q(w), { key: R }))), 128)),
              J(u.$slots, "toggleable-append"),
              v[1] || (v[1] = h("hr", { class: "vg-divider-vertical" }, null, -1))
            ])) : M("", !0),
            J(u.$slots, "default"),
            (c(!0), _(j, null, Y(l(a), (w, R) => (c(), k(q(w), { key: R }))), 128)),
            J(u.$slots, "append"),
            ((d = (p = l(t).config.topMenuItems) == null ? void 0 : p.collapsible) == null ? void 0 : d.length) !== 0 && ((m = l(t).config.componentsPool) == null ? void 0 : m.topMenuToggleableAppend) === void 0 && ((x = l(t).config.componentsPool) == null ? void 0 : x.topMenuToggleablePrepend) === void 0 ? (c(), k(l(I), {
              key: 1,
              class: "vg-top-bar-button",
              onClick: v[0] || (v[0] = () => n.value = !n.value),
              active: n.value
            }, {
              default: b(() => [
                g(l(D), { type: "cog-outline" })
              ]),
              _: 1
            }, 8, ["active"])) : M("", !0)
          ]),
          g(l(Sl), {
            class: "vg-top-bar-extra-filters-container",
            "extra-filters-expanded": l(t).extraOptions.value.extraFiltersVisible
          }, null, 8, ["extra-filters-expanded"])
        ])
      ]);
    };
  }
}), $i = { class: "vg-table-cell-boolean" }, Oi = /* @__PURE__ */ V({
  __name: "VgBodyCellBoolean",
  props: {
    ctx: {},
    columnDef: {}
  },
  setup(i) {
    const e = i, t = f(() => e.ctx.getValue()), n = f(() => t.value ? "checkbox-marked" : "checkbox-blank-outline");
    return (o, r) => (c(), _("div", $i, [
      g(l(D), { type: n.value }, null, 8, ["type"])
    ]));
  }
}), Pi = ["title"], nt = /* @__PURE__ */ V({
  __name: "VgBodyCellText",
  props: {
    ctx: {},
    columnDef: {}
  },
  setup(i) {
    const e = i, t = f(() => e.ctx.getFormattedValue());
    return (n, o) => (c(), _("div", {
      class: "vg-table-cell-text",
      title: t.value
    }, S(t.value), 9, Pi));
  }
}), zi = /* @__PURE__ */ V({
  __name: "VgEditCellBoolean",
  props: {
    value: {
      type: Boolean,
      required: !0
    },
    data: {
      type: Object,
      required: !1
    }
  },
  emits: ["update:value"],
  setup(i, { emit: e }) {
    const t = i, n = f(() => t.value ? "checkbox-marked" : "checkbox-blank-outline"), o = e;
    return (r, a) => (c(), _("div", {
      onClick: a[0] || (a[0] = () => o("update:value", !i.value)),
      class: "vg-table-cell-checkbox"
    }, [
      g(l(D), {
        role: "checkbox",
        type: n.value
      }, null, 8, ["type"])
    ]));
  }
}), Mi = /* @__PURE__ */ V({
  __name: "VgEditCellNumber",
  props: {
    value: {},
    data: {},
    ctx: {},
    columnDef: {}
  },
  emits: ["update:value"],
  setup(i, { emit: e }) {
    const t = i, n = e, o = z(t.value);
    function r(a) {
      if (o.value = a, a === "") {
        n("update:value", null);
        return;
      }
      const s = Number(a.replace(",", "."));
      isNaN(s) || n("update:value", s);
    }
    return (a, s) => (c(), k(l(oe), {
      "model-value": o.value,
      "onUpdate:modelValue": s[0] || (s[0] = (u) => r(u)),
      class: "vg-table-cell-edit-number",
      name: "vg-table-cell-edit-number"
    }, null, 8, ["model-value"]));
  }
}), Ei = /* @__PURE__ */ V({
  __name: "VgEditCellSelect",
  props: {
    value: {
      required: !0
    },
    data: {
      type: Object,
      required: !1
    }
  },
  emits: ["update:value"],
  setup(i, { emit: e }) {
    const t = i, n = e;
    return (o, r) => {
      var a, s, u;
      return c(), k(l(se), {
        "model-value": t.value,
        items: ((a = i.data) == null ? void 0 : a.filterOptions) ?? [],
        "item-title": ((s = i.data) == null ? void 0 : s.itemTitle) ?? "title",
        "item-value": ((u = i.data) == null ? void 0 : u.itemValue) ?? "value",
        class: "vg-table-cell-edit-select",
        "onUpdate:modelValue": r[0] || (r[0] = (v) => n("update:value", v))
      }, null, 8, ["model-value", "items", "item-title", "item-value"]);
    };
  }
}), it = /* @__PURE__ */ V({
  __name: "VgEditCellText",
  props: {
    value: {},
    data: {},
    ctx: {},
    columnDef: {}
  },
  emits: ["update:value"],
  setup(i, { emit: e }) {
    const t = i, n = e, o = f({
      get: () => t.value,
      set: (r) => n("update:value", r)
    });
    return (r, a) => (c(), k(l(oe), {
      modelValue: o.value,
      "onUpdate:modelValue": a[0] || (a[0] = (s) => o.value = s),
      class: "vg-table-cell-edit-text",
      name: "vg-table-cell-edit-text"
    }, null, 8, ["modelValue"]));
  }
}), pa = {
  row: {
    type: Object,
    required: !0
  },
  gridApi: {
    type: Object,
    required: !0
  }
}, ga = {
  ctx: {
    type: Object,
    required: !0
  },
  columnDef: {
    type: Object,
    required: !1
  }
}, Ti = { key: 0 }, Bi = {
  key: 1,
  class: "vg-table-body-add-row"
}, Ni = { class: "vg-table-body-content-wrapper" }, Ui = /* @__PURE__ */ V({
  __name: "VgBody",
  setup(i) {
    const { gridApi: e, i18n: t } = H(), n = e.virtualScroller, o = f(() => e.table.value.getRowModel().rows.filter((u) => !e.editing.value && (e.config.createdRowsBehaviour === "only-in-edit" || e.config.createdRowsBehaviour === void 0) ? !u.id.startsWith("vg-new-row") : !0).map((u) => ({
      id: u.id,
      row: u
    }))), r = f(() => e.table.value.getRowModel().rows), a = he({
      viewStartIdx: 0,
      viewEndIdx: 0,
      visibleStartIdx: 0,
      visibleEndIdx: 0
    });
    function s(u, v, p, d) {
      if (a.viewStartIdx = u, a.viewEndIdx = v, a.visibleStartIdx = p, a.visibleEndIdx = d, e.config.enableInfinityScroll === !0 && d > e.state.data.length - 2) {
        e.fetchMoreDataDebounced();
        const m = /* @__PURE__ */ new Set();
        for (let x = 0; x < e.state.data.length; x++)
          m.has(e.state.data[x].id) && console.error("Duplicate ID", e.state.data[x].id), m.add(e.state.data[x].id);
      }
    }
    return (u, v) => (c(), _(j, null, [
      l(e).config.debug ? (c(), _("div", Ti, [
        v[1] || (v[1] = h("b", null, "Debug =>", -1)),
        rt(" Items: " + S(o.value.length) + ", ID: " + S(l(e).id) + ", Mode: " + S(l(e).config.enableDynamicRendering ? "dynamic" : "static") + " , View: " + S(a.viewStartIdx) + " - " + S(a.viewEndIdx) + " , Visible: " + S(a.visibleStartIdx) + " - " + S(a.visibleEndIdx) + ", Editing: (enabled=" + S(l(e).config.enableEditing) + " active=" + S(l(e).editing) + "), Selected: " + S(l(e).selectedRows.value.length) + ", Updated: " + S(l(e).updatedData.length) + ", Subgrids updated: " + S(l(e).areSubgridsUpdated.value) + ", Infinity scroll: " + S(l(e).config.enableInfinityScroll) + ", Infinity scroll fetch block: " + S(l(e).blockFutherInfinityScrollFetch.value) + ", Storage Base Key: " + S(l(e).storageController.baseKey ?? "NULL"), 1)
      ])) : M("", !0),
      l(e).editing.value && l(e).config.enableRowCreation ? (c(), _("div", Bi, [
        h("div", {
          onClick: v[0] || (v[0] = () => l(e).createNewRowFromTemplate()),
          class: "vg-table-body-add-row-inner"
        }, [
          g(l(D), { type: "add-row" }),
          h("p", null, S(l(t).t("body.add_new_row")), 1)
        ])
      ])) : M("", !0),
      h("div", {
        class: "vg-table-body",
        ref: (p) => l(e).bodyElement.value = p ?? null
      }, [
        h("div", Ni, [
          l(e).config.enableDynamicRendering ? (c(), _(j, { key: 0 }, [
            g(l(Cn), {
              class: "vg-table-body-content",
              ref_key: "virtualScroller",
              ref: n,
              items: o.value,
              "min-item-size": 10,
              "skip-hover": !0,
              "emit-update": !0,
              onUpdate: s
            }, {
              default: b(({ item: p, index: d, active: m }) => [
                g(l(xn), {
                  item: p,
                  active: m,
                  "data-index": d
                }, {
                  default: b(() => [
                    g(l(lt), {
                      row: p.row,
                      index: d ?? NaN
                    }, null, 8, ["row", "index"])
                  ]),
                  _: 2
                }, 1032, ["item", "active", "data-index"])
              ]),
              _: 1
            }, 8, ["items"]),
            l(e).blockFutherInfinityScrollFetch.value ? (c(), k(l(lo), { key: 0 })) : M("", !0)
          ], 64)) : (c(!0), _(j, { key: 1 }, Y(r.value, (p, d) => (c(), k(l(lt), {
            row: p,
            index: d,
            key: p.id
          }, null, 8, ["row", "index"]))), 128))
        ])
      ], 512)
    ], 64));
  }
}), Hi = ["draggable"], Gi = /* @__PURE__ */ V({
  __name: "VgBodyCellDNDHandle",
  props: {
    ctx: {},
    columnDef: {}
  },
  setup(i) {
    const { gridApi: e } = H(), t = i, n = Be(Dt);
    if (!n)
      throw new Error("VgBodyCellDNDHandle must be used within a VgBodyRowWrapper");
    const o = (a) => {
      var s, u;
      (s = a.dataTransfer) == null || s.setData("text/plain", t.ctx.row.id), (u = a.dataTransfer) == null || u.setDragImage(new Image(), 0, 0), n.value = !0;
    }, r = () => {
      n.value = !1;
    };
    return (a, s) => (c(), _("div", {
      class: "vg-table-cell-dnd-handle",
      draggable: l(e).config.enableRowDragAndDrop ?? !1,
      onDragstart: o,
      onDragend: r
    }, [
      g(l(D), { type: "drag" })
    ], 40, Hi));
  }
}), qi = /* @__PURE__ */ V({
  __name: "VgEditCellDate",
  props: {
    value: {
      type: String,
      required: !0
    },
    data: {
      type: Object,
      required: !1
    },
    ctx: {
      type: Object,
      required: !0
    }
  },
  emits: ["update:value"],
  setup(i, { emit: e }) {
    const t = ae(), n = i, o = e;
    function r(s) {
      var u, v;
      return t.d(s, ((v = (u = n.data) == null ? void 0 : u.filterOptions) == null ? void 0 : v.dateType) ?? "datetime");
    }
    const a = f({
      get() {
        var s, u;
        if (((u = (s = n.data) == null ? void 0 : s.filterOptions) == null ? void 0 : u.dateType) === "time") {
          const v = new Date(n.value);
          return {
            hours: v.getHours(),
            minutes: v.getMinutes()
          };
        }
        return new Date(n.value);
      },
      set(s) {
        if (Object.keys(s).includes("hours")) {
          const u = new Date(n.ctx.cell.getValue());
          u.setHours(s.hours), u.setMinutes(s.minutes), o("update:value", u.toISOString());
        } else
          o("update:value", s.toISOString());
      }
    });
    return (s, u) => {
      var v, p, d, m;
      return c(), k(l(mt), {
        modelValue: a.value,
        "onUpdate:modelValue": u[0] || (u[0] = (x) => a.value = x),
        locale: l(t).locale.value,
        style: { width: "100%", height: "100%" },
        "select-text": l(t).t("filter.datetime.select"),
        "cancel-text": l(t).t("filter.datetime.cancel"),
        "time-picker": ((p = (v = n.data) == null ? void 0 : v.filterOptions) == null ? void 0 : p.dateType) === "time",
        "enable-time-picker": ((m = (d = n.data) == null ? void 0 : d.filterOptions) == null ? void 0 : m.dateType) !== "date",
        format: r
      }, null, 8, ["modelValue", "locale", "select-text", "cancel-text", "time-picker", "enable-time-picker"]);
    };
  }
}), Wi = (i, e) => {
  const t = i.__vccOpts || i;
  for (const [n, o] of e)
    t[n] = o;
  return t;
}, Li = /* @__PURE__ */ Wi(qi, [["__scopeId", "data-v-b75d37f2"]]);
function ji(i) {
  switch (i) {
    case "date":
      return Li;
    case "number":
      return Mi;
    case "select":
      return Ei;
    case "boolean":
      return zi;
    case "text":
      return it;
    default:
      return it;
  }
}
const Ki = ["title"], Ji = /* @__PURE__ */ V({
  __name: "VgBodyCellEdit",
  props: {
    ctx: {},
    columnDef: {}
  },
  setup(i) {
    const { gridApi: e } = H(), t = i, n = e.getUpdatedData(t.ctx.column.id, t.ctx.row.id), o = f({
      get: () => {
        const p = n.value;
        return p !== void 0 ? p : t.ctx.getValue();
      },
      set: (p) => {
        e.setUpdatedData(t.ctx.column.id, t.ctx.row.id, p), e.validation.validate(
          t.ctx.row.id,
          t.ctx.column.id,
          p,
          t.ctx.row.original,
          t.ctx.columnDef.validationRules
        );
      }
    });
    function r(p, d) {
      return p !== d ? typeof p == "object" && typeof d == "object" ? JSON.stringify(p) === JSON.stringify(d) : !1 : !0;
    }
    const a = f(() => ({
      "vg-body-cell-edited": !r(o.value, t.ctx.getValue())
    })), s = t.ctx.columnDef.editCell ?? ji(t.ctx.columnDef.columnType ?? "text"), u = f(() => t.ctx.columnDef.columnFilterCustomData ?? { filterOptions: {} }), v = f(() => t.ctx.getValue());
    return (p, d) => (c(), _("div", {
      class: X(["vg-table-cell", a.value]),
      title: v.value
    }, [
      (c(), k(q(l(s)), {
        value: o.value,
        "onUpdate:value": d[0] || (d[0] = (m) => o.value = m),
        data: u.value,
        ctx: t.ctx,
        "column-def": t.ctx.columnDef
      }, null, 40, ["value", "data", "ctx", "column-def"]))
    ], 10, Ki));
  }
}), Zi = ["title"], Xi = /* @__PURE__ */ V({
  __name: "VgBodyCellExpander",
  props: {
    ctx: {},
    columnDef: {}
  },
  setup(i) {
    const e = ae(), t = i, n = t.ctx.row.getToggleExpandedHandler(), o = f(() => t.ctx.row.getIsExpanded() ? "chevron-down" : "chevron-right"), r = f(() => t.ctx.row.getIsExpanded() ? e.t("expand.tooltips.compact") : e.t("expand.tooltips.expand"));
    return (a, s) => a.ctx.row.getCanExpand() && a.ctx.row.subRows.length > 0 ? (c(), _("div", {
      key: 0,
      title: r.value,
      onClick: s[0] || (s[0] = //@ts-ignore
      (...u) => l(n) && l(n)(...u)),
      role: "button",
      class: "vg-table-cell-checkbox"
    }, [
      g(l(D), { type: o.value }, null, 8, ["type"])
    ], 8, Zi)) : M("", !0);
  }
}), Yi = ["title"], Qi = /* @__PURE__ */ V({
  __name: "VgBodyCellSelect",
  props: {
    ctx: {},
    columnDef: {}
  },
  setup(i) {
    const e = ae(), t = i, n = f(() => t.ctx.row.getIsSelected() ? "close-box" : "checkbox-blank-outline"), o = f(() => t.ctx.row.getIsSelected() ? e.t("select.tooltips.selected") : e.t("select.tooltips.select"));
    return (r, a) => (c(), _("div", {
      title: o.value,
      onClick: a[0] || (a[0] = (s) => t.ctx.row.toggleSelected(!t.ctx.row.getIsSelected())),
      role: "button",
      class: "vg-table-cell-checkbox"
    }, [
      g(l(D), { type: n.value }, null, 8, ["type"])
    ], 8, Yi));
  }
}), eo = ["data-column-id"], to = ["title"], no = /* @__PURE__ */ V({
  __name: "VgBodyCellWrapper",
  props: {
    cell: {}
  },
  setup(i) {
    const e = i, t = f(() => e.cell.getContext()), { gridApi: n } = H(), o = f(() => t.value.column.id.startsWith("vg-")), r = n.validation.getInvalidCellData(t.value.row.id, t.value.column.id), a = f(() => {
      var y;
      return o.value ? "center" : (y = n.getColumnDefinitionById(t.value.column.id)) == null ? void 0 : y.justifyContent;
    }), s = n.validation.isCellInvalid(t.value.row.id, t.value.column.id), u = n.getColumnDefinitionById(e.cell.column.id), v = f(
      () => ((u == null ? void 0 : u.cellClasses) ?? []).reduce((y, O) => ({ ...y, [O]: !0 }), {})
    ), p = f(() => ({
      "vg-table-cell-wrapper": !0,
      "vg-table-cell-wrapper-body": !0,
      "vg-table-cell-wrapper--is-pinned": t.value.column.getIsPinned() !== !1,
      "vg-table-cell-wrapper--invalid": s.value && !o.value,
      ...v.value
    })), d = f(() => {
      const y = e.cell.column.getIsPinned() === "left" ? `${Ve(!0, e.cell.column.id)}px` : void 0, O = e.cell.column.getIsPinned() === "right" ? `${Ve(!1, e.cell.column.id)}px` : void 0;
      return {
        width: `${e.cell.column.getSize()}px`,
        left: y,
        right: O
      };
    }), m = f(() => ({
      justifyContent: a.value ?? n.config.defaultJustify ?? "flex-start"
    }));
    function x() {
      const { columnDef: y } = _e(e.cell.column);
      y.showDetailDrawerOnClick !== !1 && !n.editing.value && n.extraOptions.value.enableDetailDrawer === !0 && (n.clickedRow.value = t.value.row);
    }
    const w = Be(Rt), R = f(() => {
      const y = t.value.column.columnDef.cell(t.value);
      switch (y.targetMode) {
        case "normal":
          return y.normal;
        case "inlineEdit":
          return w != null && w.value ? y.edit : y.normal;
        case "edit":
          return y.edit;
        default:
          return y.normal;
      }
    });
    return (y, O) => {
      var G;
      return c(), _("div", {
        class: X(p.value),
        "data-column-id": y.cell.column.id,
        style: ue(d.value),
        onClick: x
      }, [
        g(l(be), {
          class: "vg-table-cell",
          render: R.value,
          props: t.value,
          style: ue(m.value)
        }, null, 8, ["render", "props", "style"]),
        (G = l(r)) != null && G.message ? (c(), _("p", {
          key: 0,
          class: "validation-text",
          title: l(r).message
        }, S(l(r).message), 9, to)) : M("", !0)
      ], 14, eo);
    };
  }
}), io = ["title"], oo = { class: "vg-fetch-more-data-button" }, lo = /* @__PURE__ */ V({
  __name: "VgBodyFetchMore",
  setup(i) {
    const { gridApi: e, i18n: t } = H();
    async function n() {
      e.blockFutherInfinityScrollFetch.value = !1, await e.fetchMoreDataDebounced();
    }
    return (o, r) => (c(), _("div", {
      class: "vg-table-row-wrapper vg-table-row-wrapper-body",
      title: l(t).t("infinity_scroll.retry")
    }, [
      g(l(I), {
        onClick: n,
        block: "",
        class: "vg-fetch-more-data-container"
      }, {
        default: b(() => [
          h("div", oo, [
            g(l(D), { type: "refresh" }),
            h("h3", null, S(l(t).t("infinity_scroll.retry")), 1)
          ])
        ]),
        _: 1
      })
    ], 8, io));
  }
}), ao = ["data-row-id", "data-row-index", "data-subrow-level"], ro = { class: "vg-table-row-content" }, ot = /* @__PURE__ */ V({
  __name: "VgBodyRow",
  props: {
    row: {},
    gridApi: {}
  },
  setup(i) {
    const e = i, t = f(() => {
      const n = e.row.id.startsWith("vg-new-row");
      return {
        "vg-table-row--new-row": n,
        "vg-table-row--disabled": n && e.gridApi.config.createdRowsBehaviour === "disable-pointer-events-in-render"
      };
    });
    return (n, o) => (c(), _("div", {
      class: X(["vg-table-row vg-table-row-body", t.value]),
      "data-row-id": n.row.id,
      "data-row-index": n.row.index,
      "data-subrow-level": n.row.depth
    }, [
      h("div", ro, [
        (c(!0), _(j, null, Y(n.row.getVisibleCells(), (r) => (c(), k(no, {
          key: r.id,
          cell: r
        }, null, 8, ["cell"]))), 128))
      ])
    ], 10, ao));
  }
}), so = { style: { width: "100%", height: "100px", display: "grid", "place-content": "center" } }, uo = /* @__PURE__ */ V({
  __name: "VgBodyRowDetail",
  props: {
    row: {},
    gridApi: {}
  },
  setup(i) {
    return (e, t) => (c(), _("div", so, t[0] || (t[0] = [
      h("i", null, "This is default Detail Component, provide your own component ...", -1)
    ])));
  }
}), co = ["data-type"], po = ["title"], go = ["title"], lt = /* @__PURE__ */ V({
  __name: "VgBodyRowWrapper",
  props: {
    row: {},
    index: {}
  },
  setup(i) {
    const e = i, { gridApi: t, i18n: n } = H(), { bodyRowRender: o, bodySubRowRender: r, bodyDetailRowRender: a } = Gt(t), s = z(null), u = f(() => {
      const { row: A } = e;
      return A.depth === 0 ? "row" : ke(A.original) ? "detail" : "subrow";
    }), v = f(() => {
      const { row: A } = e;
      return ke(A.original) ? a : A.depth > 0 ? r : o;
    }), p = z(!1);
    Fe(Dt, p);
    const d = z(!1), m = t.validation.isRowInvalid(e.row.id), x = f(() => m.value && (d.value || t.editing)), w = f(() => ({
      "vg-table-row-wrapper": !0,
      "vg-table-row-wrapper-body": !0,
      "vg-table-row-wrapper--row-invalid": x.value,
      "vg-table-row-wrapper--dragged": p.value
    })), R = f(() => e.index);
    function y() {
      s.value && t.config.onRowRender && t.config.onRowRender({
        element: s.value,
        data: e.row,
        index: e.index,
        grid: t
      });
    }
    de(R, y), Ue(() => {
      y();
    }), Ce.on(we.rowRenderCallbackTrigger, y);
    const O = f(() => e.row.id.startsWith("vg-new-row-"));
    Fe(Rt, d);
    const G = (A) => {
      var W;
      A.preventDefault(), A.stopPropagation();
      const E = (W = A.dataTransfer) == null ? void 0 : W.getData("text/plain");
      E && E !== e.row.id && t.config.onRowDrop && t.config.onRowDrop({
        initiator: E,
        target: e.row.id,
        grid: t
      });
    };
    function P() {
      t.removeRow(e.row.id);
    }
    function T() {
      d.value = !d.value;
    }
    const C = f(() => {
      const A = t.config.getRowId;
      return t.updatedData.some((E) => E.id === A(e.row.original));
    }), F = f(() => ({
      "vg-table-row-wrapper__inline-edit": !0,
      "vg-table-row-wrapper__inline-edit--change": C.value,
      "vg-table-row-wrapper__inline-edit--no-change": !C.value
    }));
    return (A, E) => (c(), _("div", {
      class: X(w.value),
      "data-type": u.value,
      ref_key: "wrapperRef",
      ref: s,
      onDrop: G,
      onDragover: E[0] || (E[0] = le(() => {
      }, ["prevent"]))
    }, [
      l(t).config.enableEditing === "inline" ? (c(), _("div", {
        key: 0,
        class: X(F.value),
        onClick: T,
        title: l(n).t("body.edit_row")
      }, [
        g(l(D), { type: "pencil-outline" })
      ], 10, po)) : M("", !0),
      g(l(be), {
        render: v.value,
        props: { row: A.row, gridApi: l(t) }
      }, null, 8, ["render", "props"]),
      O.value ? (c(), _("div", {
        key: 1,
        class: "vg-table-row-wrapper__new-row",
        onClick: P,
        title: l(n).t("body.delete_row")
      }, [
        g(l(D), { type: "close" })
      ], 8, go)) : M("", !0)
    ], 42, co));
  }
}), fo = /* @__PURE__ */ V({
  __name: "VgDetailDrawer",
  setup(i) {
    const { gridApi: e } = H(), t = f(
      () => K(e.componentsPool.detailDrawerComponent)
    ), n = f(
      () => {
        var r;
        return (r = t.value) != null && r.component ? t.value.component : _o;
      }
    ), o = f({
      get() {
        return e.config.enableDetailDrawer !== !0 ? !1 : e.clickedRow.value !== null;
      },
      set() {
        e.clickedRow.value = null;
      }
    });
    return (r, a) => (c(), k(l(An), L({
      value: o.value,
      onClose: a[0] || (a[0] = (s) => o.value = !1)
    }, l(e).config.detailDrawerProps), {
      default: b(() => {
        var s, u;
        return [
          (c(), k(q(n.value), L({
            grid: l(e),
            row: (s = l(e).clickedRow) == null ? void 0 : s.value
          }, (u = t.value) == null ? void 0 : u.props), null, 16, ["grid", "row"]))
        ];
      }),
      _: 1
    }, 16, ["value"]));
  }
}), vo = { class: "vg-detail-drawer-default-icon-wrapper" }, mo = { class: "vg-detail-drawer-default-wrapper" }, ho = ["title"], bo = ["title"], _o = /* @__PURE__ */ V({
  __name: "VgDetailDrawerSimple",
  props: {
    grid: {
      type: Object,
      required: !0
    },
    row: {
      type: Object,
      required: !1
    }
  },
  setup(i) {
    const e = i, t = f(() => {
      const n = /* @__PURE__ */ new Map();
      if (!e.row) return n;
      for (const o of e.row.getAllCells()) {
        const r = o.column, { valueFormatter: a, columnDef: s } = _e(r), u = s.headerName ?? o.column.id;
        if (!o.column.id.startsWith("vg-")) {
          if (a) {
            n.set(
              u,
              a(o.getValue(), { i18n: e.grid.i18n.value, cell: o, grid: e.grid })
            );
            continue;
          }
          n.set(u, o.getValue());
        }
      }
      return n;
    });
    return (n, o) => (c(), _(j, null, [
      h("div", vo, [
        g(l(D), {
          type: "close",
          class: "vg-detail-drawer-default-icon",
          onClick: o[0] || (o[0] = (r) => i.grid.clickedRow.value = null)
        })
      ]),
      h("div", mo, [
        (c(!0), _(j, null, Y(t.value, ([r, a]) => (c(), _("div", { key: r }, [
          h("div", {
            class: "vg-detail-drawer-default-label",
            title: r
          }, S(r), 9, ho),
          h("div", {
            class: "vg-detail-drawer-default-value",
            title: a
          }, S(a), 9, bo)
        ]))), 128))
      ])
    ], 64));
  }
}), yo = { class: "vg-detail-drawer-default-icon-wrapper" }, wo = { class: "vg-detail-drawer-component-wrapper" }, Co = {
  key: 0,
  class: "vg-detail-drawer-component-item"
}, xo = ["title"], fa = /* @__PURE__ */ V({
  __name: "VgDetailDrawerWithComponents",
  props: {
    grid: {
      type: Object,
      required: !0
    },
    row: {
      type: Object,
      required: !1
    }
  },
  setup(i) {
    const e = i, t = f(() => {
      var o;
      return ((o = e.row) == null ? void 0 : o.getAllCells()) ?? [];
    }), n = f(() => t.value.map((r) => {
      const a = r.getContext(), s = a.column.columnDef.cell(a), u = Oe(a);
      return {
        cell: s.normal,
        ctx: a,
        name: u.ctx.columnDef.headerName,
        gridDef: u.ctx.columnDef
      };
    }).filter((r) => !r.ctx.column.id.startsWith("vg-")));
    return (o, r) => (c(), _(j, null, [
      h("div", yo, [
        g(l(D), {
          type: "close",
          class: "vg-detail-drawer-default-icon",
          onClick: r[0] || (r[0] = (a) => i.grid.clickedRow.value = null)
        })
      ]),
      h("div", wo, [
        (c(!0), _(j, null, Y(n.value, (a, s) => (c(), _("div", {
          key: s,
          class: "vg-detail-drawer-component-item-wrapper"
        }, [
          a.name ? (c(), _("div", Co, [
            h("div", {
              class: "vg-detail-drawer-default-label",
              title: a.name
            }, S(a.name), 9, xo),
            g(l(be), {
              class: "vg-detail-drawer-default-value",
              render: a.cell,
              props: a.ctx
            }, null, 8, ["render", "props"])
          ])) : M("", !0)
        ]))), 128))
      ])
    ], 64));
  }
});
function ee(i, e) {
  var n;
  const t = e ?? "equal";
  return i ? ((n = i[0]) == null ? void 0 : n.value) ?? t : t;
}
const va = {
  ctx: {
    type: Object,
    required: !0
  }
}, ma = {
  headerGroup: {
    type: Object,
    required: !0
  }
}, So = { class: "vg-table-row-wrapper" }, Vo = /* @__PURE__ */ V({
  __name: "VgHeaderRowWrapper",
  props: {
    headerGroup: {}
  },
  setup(i) {
    const e = i, { gridApi: t } = H(), { headerRowRender: n } = Gt(t), o = f(() => ({ headerGroup: e.headerGroup }));
    return (r, a) => (c(), _("div", So, [
      g(l(be), {
        render: l(n),
        props: o.value
      }, null, 8, ["render", "props"])
    ]));
  }
}), ko = { class: "vg-table-header" }, Do = { class: "vg-table-header-content" }, Ro = /* @__PURE__ */ V({
  __name: "VgHeader",
  setup(i) {
    const { gridApi: e } = H(), t = f(() => e.table.value.getHeaderGroups());
    return (n, o) => (c(), _("div", ko, [
      h("div", Do, [
        (c(!0), _(j, null, Y(t.value, (r) => (c(), k(Vo, {
          key: r.id,
          "header-group": r
        }, null, 8, ["header-group"]))), 128))
      ])
    ]));
  }
}), Ao = { class: "vg-header-more-container" }, Io = { class: "vg-header-more-header" }, Fo = /* @__PURE__ */ V({
  __name: "VgHeaderMore",
  props: {
    ctx: {},
    meta: {},
    outputs: {},
    relationFilterValues: {}
  },
  setup(i) {
    const { i18n: e, gridApi: t } = H(), n = i, o = t.getColumnDefinitionById(n.ctx.column.id), r = t.hasColumnChildren(n.ctx.column.id), a = f(() => (n.outputs[0] !== null || n.outputs[1] !== null || n.relationFilterValues[0] !== ee(o == null ? void 0 : o.relationOverride) || n.relationFilterValues[1] !== ee(o == null ? void 0 : o.relationOverride)) && d.value);
    function s(x) {
      const w = n.ctx.table.getAllLeafColumns().map((O) => O.id), R = w.indexOf(n.ctx.column.id), y = w.slice();
      y.splice(R, 1), y.splice(R + x, 0, n.ctx.column.id), n.ctx.table.setColumnOrder(y);
    }
    const u = f(() => n.ctx.table.getAllLeafColumns().map((w) => w.id).indexOf(n.ctx.column.id)), v = f(() => n.ctx.table.getAllLeafColumns().length - 1), p = f(() => n.ctx.column.getCanSort()), d = f(() => n.ctx.column.getCanFilter());
    function m() {
      t.extraOptions.value.filtersVisible = !t.extraOptions.value.filtersVisible;
    }
    return (x, w) => (c(), _("div", Ao, [
      h("div", Io, [
        h("h2", null, S(n.meta.columnDef.headerName), 1)
      ]),
      g(l(I), {
        onClick: m,
        active: l(t).extraOptions.value.filtersVisible
      }, {
        prepend: b(() => [
          g(l(D), { type: "filter" })
        ]),
        default: b(() => [
          h("p", null, S(l(e).t("more_menu.toggle_filters")), 1)
        ]),
        _: 1
      }, 8, ["active"]),
      g(l(I), {
        onClick: w[0] || (w[0] = () => l(t).filters.clearFilter(n.ctx.column.id)),
        disabled: !a.value
      }, {
        prepend: b(() => [
          g(l(D), { type: "trash-can-outline" })
        ]),
        default: b(() => [
          h("p", null, S(l(e).t("more_menu.clear_filter")), 1)
        ]),
        _: 1
      }, 8, ["disabled"]),
      w[10] || (w[10] = h("hr", { class: "vg-divider-horizontal" }, null, -1)),
      g(l(I), {
        onClick: w[1] || (w[1] = () => n.ctx.column.toggleSorting(!1, n.ctx.column.getCanMultiSort() && l(t).config.enableMultiSort)),
        disabled: !p.value,
        active: n.ctx.column.getIsSorted() === "asc"
      }, {
        prepend: b(() => [
          g(l(D), { type: "arrow-up" })
        ]),
        default: b(() => [
          h("p", null, S(l(e).t("more_menu.sort_ascending")), 1)
        ]),
        _: 1
      }, 8, ["disabled", "active"]),
      g(l(I), {
        onClick: w[2] || (w[2] = () => n.ctx.column.toggleSorting(!0, n.ctx.column.getCanMultiSort() && l(t).config.enableMultiSort)),
        disabled: !p.value,
        active: n.ctx.column.getIsSorted() === "desc"
      }, {
        prepend: b(() => [
          g(l(D), { type: "arrow-down" })
        ]),
        default: b(() => [
          h("p", null, S(l(e).t("more_menu.sort_descending")), 1)
        ]),
        _: 1
      }, 8, ["disabled", "active"]),
      g(l(I), {
        onClick: w[3] || (w[3] = () => n.ctx.column.clearSorting()),
        disabled: !p.value || !n.ctx.column.getIsSorted()
      }, {
        prepend: b(() => [
          g(l(D), { type: "trash-can-outline" })
        ]),
        default: b(() => [
          h("p", null, S(l(e).t("more_menu.clear_sorter")), 1)
        ]),
        _: 1
      }, 8, ["disabled"]),
      w[11] || (w[11] = h("hr", { class: "vg-divider-horizontal" }, null, -1)),
      g(l(I), {
        onClick: w[4] || (w[4] = () => s(-1)),
        disabled: u.value === 0 || l(r)
      }, {
        prepend: b(() => [
          g(l(D), { type: "controls-prev" })
        ]),
        default: b(() => [
          h("p", null, S(l(e).t("more_menu.move_left")), 1)
        ]),
        _: 1
      }, 8, ["disabled"]),
      g(l(I), {
        onClick: w[5] || (w[5] = () => s(1)),
        disabled: u.value === v.value || l(r)
      }, {
        prepend: b(() => [
          g(l(D), { type: "controls-next" })
        ]),
        default: b(() => [
          h("p", null, S(l(e).t("more_menu.move_right")), 1)
        ]),
        _: 1
      }, 8, ["disabled"]),
      w[12] || (w[12] = h("hr", { class: "vg-divider-horizontal" }, null, -1)),
      g(l(I), {
        onClick: w[6] || (w[6] = () => n.ctx.column.pin("left")),
        disabled: !n.ctx.column.getCanPin() || l(r),
        active: n.ctx.column.getIsPinned() === "left"
      }, {
        prepend: b(() => [
          g(l(D), { type: "lock-left" })
        ]),
        default: b(() => [
          h("p", null, S(l(e).t("more_menu.pin_left")), 1)
        ]),
        _: 1
      }, 8, ["disabled", "active"]),
      g(l(I), {
        onClick: w[7] || (w[7] = () => n.ctx.column.pin("right")),
        disabled: !n.ctx.column.getCanPin() || l(r),
        active: n.ctx.column.getIsPinned() === "right"
      }, {
        prepend: b(() => [
          g(l(D), { type: "lock-right" })
        ]),
        default: b(() => [
          h("p", null, S(l(e).t("more_menu.pin_right")), 1)
        ]),
        _: 1
      }, 8, ["disabled", "active"]),
      g(l(I), {
        onClick: w[8] || (w[8] = () => n.ctx.column.pin(!1)),
        disabled: !n.ctx.column.getCanPin() || n.ctx.column.getIsPinned() === !1
      }, {
        prepend: b(() => [
          g(l(D), { type: "lock-open-outline" })
        ]),
        default: b(() => [
          h("p", null, S(l(e).t("more_menu.unpin")), 1)
        ]),
        _: 1
      }, 8, ["disabled"]),
      w[13] || (w[13] = h("hr", { class: "vg-divider-horizontal" }, null, -1)),
      g(l(I), {
        onClick: w[9] || (w[9] = () => n.ctx.column.toggleVisibility(!1)),
        disabled: !n.ctx.column.getCanHide() || l(r)
      }, {
        prepend: b(() => [
          g(l(D), { type: "eye-off-outline" })
        ]),
        default: b(() => [
          h("p", null, S(l(e).t("more_menu.hide")), 1)
        ]),
        _: 1
      }, 8, ["disabled"])
    ]));
  }
}), $o = ["title"], Oo = { class: "vg-column-label-text" }, Po = { class: "vg-header-cell" }, zo = ["title"], Mo = /* @__PURE__ */ V({
  __name: "VgHeaderCell",
  props: {
    ctx: {}
  },
  setup(i) {
    const { gridApi: e, i18n: t } = H(), n = i, o = _e(n.ctx.column), r = o.columnDef.headerName, a = e.getColumnDefinitionById(n.ctx.column.id), s = o.columnDef.tooltip, u = f(() => n.ctx.column.getCanSort());
    function v() {
      n.ctx.column.getCanSort() && n.ctx.column.toggleSorting(void 0, n.ctx.column.getCanMultiSort() && e.config.enableMultiSort);
    }
    const p = f(() => {
      switch (n.ctx.header.column.getIsSorted()) {
        case "asc":
          return "arrow-up";
        case "desc":
          return "arrow-down";
        case !1:
          return "chevron-up-down";
        default:
          return "chevron-up-down";
      }
    }), d = f({
      get: () => {
        var y;
        return ((y = e.filters.getColumnFilter(n.ctx.column.id)) == null ? void 0 : y.data) ?? [null, null];
      },
      set: (y) => {
        e.filters.setFilter(n.ctx.column.id, y, m.value);
      }
    }), m = f({
      get: () => {
        var y;
        return ((y = e.filters.getColumnFilter(n.ctx.column.id)) == null ? void 0 : y.data) ?? [
          ee(a == null ? void 0 : a.relationOverride),
          ee(a == null ? void 0 : a.relationOverride)
        ];
      },
      set: (y) => {
        e.filters.setFilter(n.ctx.column.id, d.value, y);
      }
    }), x = f(() => {
      var y;
      return ((y = e.getColumnDefinitionById(n.ctx.column.id)) == null ? void 0 : y.enableMoreMenu) ?? !0;
    }), w = z(!1);
    function R(y) {
      e.config.enableHeaderContextMenuOnRightClick !== !1 && (y.preventDefault(), w.value = !w.value);
    }
    return (y, O) => (c(), _("div", null, [
      h("div", {
        class: "vg-column-label-wrapper",
        onClick: O[2] || (O[2] = (G) => l(e).extraOptions.value.filtersVisible = !l(e).extraOptions.value.filtersVisible),
        onContextmenu: R
      }, [
        h("div", {
          class: "vg-column-label",
          title: l(s)
        }, [
          h("div", Oo, S(l(r)), 1)
        ], 8, $o),
        h("div", Po, [
          u.value ? (c(), k(l(I), {
            key: 0,
            title: l(t).t("header.tooltips.sort"),
            onClick: le(v, ["stop"]),
            class: "vg-header-cell-sort-button"
          }, {
            default: b(() => [
              g(l(D), { type: p.value }, null, 8, ["type"])
            ]),
            _: 1
          }, 8, ["title"])) : M("", !0),
          x.value ? (c(), _("div", {
            key: 1,
            class: "vg-column-more-wrapper",
            title: l(t).t("more_menu.tooltips.main")
          }, [
            g(l(pe), {
              modelValue: w.value,
              "onUpdate:modelValue": O[1] || (O[1] = (G) => w.value = G)
            }, {
              "dropdown-anchor": b(() => [
                g(l(I), L({ ref: "showMoreMenuButtonRef" }, n, { style: { height: "24px", width: "24px" } }), {
                  default: b(() => [
                    g(l(D), { type: "more-vertical" })
                  ]),
                  _: 1
                }, 16)
              ]),
              default: b(() => [
                g(Fo, {
                  onClick: O[0] || (O[0] = le(() => {
                  }, ["stop"])),
                  ctx: n.ctx,
                  meta: l(o),
                  outputs: d.value,
                  "relation-filter-values": m.value
                }, null, 8, ["ctx", "meta", "outputs", "relation-filter-values"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ], 8, zo)) : M("", !0)
        ])
      ], 32),
      l(e).filters.isColumnFilterEnabled(n.ctx.column.id) && l(e).extraOptions.value.filtersVisible ? (c(), k(l(Xn), {
        key: 0,
        relations: m.value,
        "onUpdate:relations": O[3] || (O[3] = (G) => m.value = G),
        column: y.ctx.header.column,
        "column-def": l(a)
      }, null, 8, ["relations", "column", "column-def"])) : M("", !0)
    ]));
  }
}), Eo = /* @__PURE__ */ V({
  __name: "VgHeaderCellDNDHandle",
  props: {
    ctx: {}
  },
  setup(i) {
    return (e, t) => (c(), _("div"));
  }
}), To = ["title"], Bo = /* @__PURE__ */ V({
  __name: "VgHeaderCellExpander",
  props: {
    ctx: {}
  },
  setup(i) {
    const e = ae(), t = i, n = f(() => t.ctx.table.getIsSomeRowsExpanded() ? "chevron-down" : "chevron-right");
    function o() {
      const a = t.ctx.table.getIsSomeRowsExpanded();
      t.ctx.table.toggleAllRowsExpanded(!a);
    }
    const r = f(() => t.ctx.table.getIsSomeRowsExpanded() ? e.t("expand.tooltips.compact") : e.t("expand.tooltips.expand"));
    return (a, s) => (c(), _("div", {
      title: r.value,
      onClick: o,
      class: "vg-header-cell-checkbox"
    }, [
      g(l(D), { type: n.value }, null, 8, ["type"])
    ], 8, To));
  }
}), No = ["title"], Uo = /* @__PURE__ */ V({
  __name: "VgHeaderCellSelect",
  props: {
    ctx: {}
  },
  setup(i) {
    const e = ae(), t = i, n = f(() => t.ctx.table.getIsAllRowsSelected() ? "close-box" : t.ctx.table.getIsSomeRowsSelected() ? "minus-box" : "checkbox-blank-outline"), o = f(() => t.ctx.table.getIsAllRowsSelected() ? e.t("select.tooltips.selected") : t.ctx.table.getIsSomeRowsSelected() ? e.t("select.tooltips.some_selected") : e.t("select.tooltips.select"));
    return (r, a) => (c(), _("div", {
      title: o.value,
      onClick: a[0] || (a[0] = (s) => t.ctx.table.toggleAllRowsSelected(
        !(t.ctx.table.getIsSomeRowsSelected() || t.ctx.table.getIsAllRowsSelected())
      )),
      role: "checkbox",
      class: "vg-header-cell-checkbox"
    }, [
      g(l(D), { type: n.value }, null, 8, ["type"])
    ], 8, No));
  }
}), Ho = ["draggable"], Go = /* @__PURE__ */ V({
  __name: "VgHeaderCellWrapper",
  props: {
    header: {}
  },
  setup(i) {
    const e = i, { gridApi: t } = H(), n = t.getColumnDefinitionById(e.header.column.id), o = f(
      () => ((n == null ? void 0 : n.headerClasses) ?? []).reduce((R, y) => ({ ...R, [y]: !0 }), {})
    ), r = f(() => ({
      "vg-table-cell-wrapper": !0,
      "vg-table-cell-wrapper-header": !0,
      "vg-table-cell-wrapper-header--is-resizing": e.header.column.getIsResizing(),
      "vg-table-cell-wrapper-header--is-placeholder": e.header.isPlaceholder,
      "vg-table-cell-wrapper-header--is-sortable": !e.header.isPlaceholder && e.header.column.getCanSort(),
      "vg-table-cell-wrapper-header--is-pinned": e.header.column.getIsPinned() !== !1,
      ...o.value
    })), a = f(() => {
      const R = e.header.getSize(), y = e.header.column.columnDef.minSize, O = e.header.column.columnDef.maxSize, G = e.header.column.getIsPinned() === "left" ? `${Ve(!0, e.header.column.id)}px` : void 0, P = e.header.column.getIsPinned() === "right" ? `${Ve(!1, e.header.column.id)}px` : void 0;
      return {
        width: `${R}px`,
        maxWidth: `${O}px`,
        minWidth: `${y}px`,
        left: G,
        right: P
      };
    }), s = f(() => {
      const { minSize: R, maxSize: y } = e.header.column.columnDef;
      return {
        "data-column-id": e.header.column.id,
        "data-size-min": R,
        "data-size-max": y
      };
    }), u = e.header.getResizeHandler(), v = z(null);
    function p() {
      v.value && v.value.classList.remove("vg-table-cell-wrapper-header--dragged");
    }
    const d = (R) => {
      var O;
      (O = R.dataTransfer) == null || O.setData("text/plain", e.header.column.id), R.target.classList.add("vg-table-cell-wrapper-header--dragged");
    }, m = () => {
      p();
    }, x = (R) => {
      R.preventDefault();
    }, w = (R) => {
      var O;
      R.preventDefault();
      const y = (O = R.dataTransfer) == null ? void 0 : O.getData("text/plain");
      y && e.header.column.id !== y && t.moveColumn(y, e.header.column.id);
    };
    return (R, y) => (c(), _("div", L({
      draggable: e.header.column.columns.length === 0 && !e.header.isPlaceholder && l(t).extraOptions.value.dragAndDrop === !0,
      class: r.value,
      style: a.value,
      ref_key: "self",
      ref: v
    }, s.value, {
      onDragstart: d,
      onDragenter: x,
      onDragend: m,
      onDragover: y[1] || (y[1] = le(() => {
      }, ["prevent"])),
      onDrop: w
    }), [
      R.header.isPlaceholder ? M("", !0) : (c(), k(l(be), {
        key: 0,
        class: "vg-table-cell",
        render: R.header.column.columnDef.header,
        props: R.header.getContext()
      }, null, 8, ["render", "props"])),
      R.header.column.getCanResize() && !R.header.isPlaceholder ? (c(), _("div", {
        key: 1,
        class: "vg-table-cell-resizer",
        onMousedown: y[0] || (y[0] = le(
          //@ts-ignore
          (...O) => l(u) && l(u)(...O),
          ["prevent"]
        ))
      }, null, 32)) : M("", !0)
    ], 16, Ho));
  }
}), qo = { class: "vg-table-row vg-table-row-header" }, Wo = { class: "vg-table-row-content" }, Lo = /* @__PURE__ */ V({
  __name: "VgHeaderRow",
  props: {
    headerGroup: {}
  },
  setup(i) {
    const e = i;
    return (t, n) => (c(), _("div", qo, [
      h("div", Wo, [
        (c(!0), _(j, null, Y(e.headerGroup.headers, (o) => (c(), k(Go, {
          key: o.id,
          header: o
        }, null, 8, ["header"]))), 128))
      ])
    ]));
  }
}), jo = { class: "vg-accessibility-container" }, Ko = { class: "vg-accessibility-header" }, Jo = { class: "vg-accessibility-font-items" }, Zo = { class: "vg-accessibility-font-text" }, Xo = { class: "vg-accessibility-font-items" }, Yo = { class: "vg-accessibility-font-text" }, Qo = { class: "vg-accessibility-font-items" }, el = { class: "vg-accessibility-font-text" }, tl = { class: "vg-accessibility-font-items" }, nl = { class: "vg-accessibility-font-text" }, il = /* @__PURE__ */ V({
  __name: "VgTopMenuAccessibility",
  props: {
    gridApi: {},
    i18n: {}
  },
  setup(i) {
    const e = i;
    function t() {
      e.gridApi.extraOptions.value.accessibility.fontWeight = e.gridApi.extraOptions.value.accessibility.fontWeight === "inherit" ? "bold" : "inherit";
    }
    const n = f({
      get: () => e.gridApi.extraOptions.value.accessibility.rowHeightMultiplier,
      set: (o) => {
        e.gridApi.extraOptions.value.accessibility.rowHeightMultiplier = +(o ?? 1) || 1;
      }
    });
    return (o, r) => (c(), k(l(pe), null, {
      "dropdown-anchor": b(({ dropdownActive: a }) => [
        g(l(I), L({ class: "vg-top-bar-button" }, e, {
          title: o.i18n.t("top_menu.tooltips.accessibility"),
          active: a
        }), {
          default: b(() => [
            g(l(D), { type: "format-font" })
          ]),
          _: 2
        }, 1040, ["title", "active"])
      ]),
      default: b(() => [
        h("div", jo, [
          h("h3", Ko, S(o.i18n.t("top_menu.tooltips.accessibility")), 1),
          g(l(I), {
            class: "vg-top-bar-font-items",
            onClick: t,
            active: o.gridApi.extraOptions.value.accessibility.fontWeight === "bold"
          }, {
            default: b(() => [
              g(l(D), { type: "format-bold" }),
              h("p", null, S(o.i18n.t("top_menu.bold")), 1)
            ]),
            _: 1
          }, 8, ["active"]),
          h("div", Jo, [
            h("div", Zo, S(o.i18n.t("top_menu.font_size")), 1),
            g(l(oe), {
              modelValue: o.gridApi.extraOptions.value.accessibility.fontSize,
              "onUpdate:modelValue": r[0] || (r[0] = (a) => o.gridApi.extraOptions.value.accessibility.fontSize = a),
              class: "vg-column-text-filter",
              label: "Font size"
            }, null, 8, ["modelValue"])
          ]),
          h("div", Xo, [
            h("div", Yo, S(o.i18n.t("top_menu.font_family")), 1),
            g(l(se), {
              modelValue: o.gridApi.extraOptions.value.accessibility.fontFamily,
              "onUpdate:modelValue": r[1] || (r[1] = (a) => o.gridApi.extraOptions.value.accessibility.fontFamily = a),
              items: [
                {
                  value: "-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen-Sans, Ubuntu, Cantarell, Helvetica Neue, sans-serif",
                  title: "Grid"
                },
                { value: "Inter", title: "Inter" },
                { value: "Segoe UI", title: "Segoe UI" },
                { value: "Roboto", title: "Roboto" },
                { value: "monospace", title: "Monospace" },
                { value: "sans-serif", title: "Sans-serif" },
                { value: "inherit", title: "Inherit" }
              ]
            }, null, 8, ["modelValue"])
          ]),
          h("div", Qo, [
            h("div", el, S(o.i18n.t("top_menu.row_height")), 1),
            g(l(oe), {
              modelValue: n.value,
              "onUpdate:modelValue": r[2] || (r[2] = (a) => n.value = a),
              modelModifiers: { number: !0 }
            }, null, 8, ["modelValue"])
          ]),
          h("div", tl, [
            h("div", nl, S(o.i18n.t("top_menu.grid_content_height")), 1),
            g(l(oe), {
              modelValue: o.gridApi.extraOptions.value.accessibility.gridContentHeight,
              "onUpdate:modelValue": r[3] || (r[3] = (a) => o.gridApi.extraOptions.value.accessibility.gridContentHeight = a),
              modelModifiers: { number: !0 },
              disabled: !o.gridApi.config.enableGridResizeByUser
            }, null, 8, ["modelValue", "disabled"])
          ])
        ])
      ]),
      _: 1
    }));
  }
}), ol = /* @__PURE__ */ V({
  __name: "VgTopMenuClearFilters",
  props: {
    gridApi: {},
    i18n: {}
  },
  setup(i) {
    const e = i, t = f(
      () => (e.gridApi.filters.filterState.value.length ?? 0) > 0 || e.gridApi.filters.relationStateInternal.value.length > 0
    );
    return (n, o) => (c(), k(l(Ge), { show: t.value }, {
      default: b(() => [
        g(l(I), {
          class: "vg-top-bar-button",
          onClick: o[0] || (o[0] = () => e.gridApi.filters.resetFilters()),
          title: n.i18n.t("top_menu.tooltips.clear_filters")
        }, {
          default: b(() => [
            g(l(D), { type: "filter-remove-outline" })
          ]),
          _: 1
        }, 8, ["title"])
      ]),
      _: 1
    }, 8, ["show"]));
  }
}), ll = { class: "vg-column-visibility-container" }, al = { class: "vg-column-visibility-header" }, rl = { class: "vg-column-visibility-button-wrapper" }, sl = { class: "vg-column-visibility-wrapper" }, ul = { class: "vg-column-visibility-badge-label" }, dl = /* @__PURE__ */ V({
  __name: "VgTopMenuColumnVisibility",
  props: {
    gridApi: {},
    i18n: {}
  },
  setup(i) {
    const e = i;
    function t(p) {
      return p.startsWith("vg-");
    }
    const n = f(
      () => e.gridApi.table.value.getAllFlatColumns().map((p) => p.id).filter((p) => !t(p))
    ), o = f(
      () => {
        var p;
        return (p = e.gridApi.table.value) == null ? void 0 : p.getAllFlatColumns().filter((d) => !d.id.startsWith("vg-") && d.getIsVisible()).map((d) => d.id).filter((d) => !t(d));
      }
    ), r = f(() => n.value.filter((p) => {
      var d;
      return !((d = o.value) != null && d.includes(p));
    }));
    function a() {
      var p;
      (p = e.gridApi.table.value) == null || p.getAllFlatColumns().filter((d) => !t(d.id)).forEach((d) => d.toggleVisibility(!1));
    }
    function s() {
      var p;
      (p = e.gridApi.table.value) == null || p.getAllFlatColumns().filter((d) => !t(d.id)).forEach((d) => d.toggleVisibility(!0));
    }
    const u = f(() => {
      var p;
      return (p = e.gridApi.table.value) == null ? void 0 : p.getAllFlatColumns().filter((d) => !t(d.id));
    }), v = f(() => {
      var p;
      return ((p = u.value) == null ? void 0 : p.filter((d) => !e.gridApi.hasColumnChildren(d.id))) || [];
    });
    return (p, d) => (c(), k(l(pe), null, {
      "dropdown-anchor": b(({ dropdownActive: m }) => [
        g(l(Ge), {
          show: r.value.length > 0
        }, {
          default: b(() => [
            g(l(I), {
              class: "vg-top-bar-button",
              title: p.i18n.t("top_menu.tooltips.column_visibility"),
              active: m
            }, {
              default: b(() => [
                g(l(D), { type: "eye-off-outline" })
              ]),
              _: 2
            }, 1032, ["title", "active"])
          ]),
          _: 2
        }, 1032, ["show"])
      ]),
      default: b(() => [
        h("div", ll, [
          h("h3", al, S(e.i18n.t("top_menu.tooltips.column_visibility")), 1),
          h("div", rl, [
            g(l(I), { onClick: a }, {
              prepend: b(() => [
                g(l(D), { type: "eye-off-outline" })
              ]),
              default: b(() => [
                h("p", null, S(e.i18n.t("top_menu.hide_all")), 1)
              ]),
              _: 1
            }),
            g(l(I), { onClick: s }, {
              prepend: b(() => [
                g(l(D), { type: "eye-outline" })
              ]),
              default: b(() => [
                h("p", null, S(e.i18n.t("top_menu.show_all")), 1)
              ]),
              _: 1
            })
          ]),
          d[0] || (d[0] = h("hr", { class: "vg-divider-horizontal" }, null, -1)),
          h("div", sl, [
            (c(!0), _(j, null, Y(v.value, (m) => {
              var x;
              return c(), _("div", {
                key: m.id,
                class: "vg-column-visibility-item"
              }, [
                g(l(Rn), {
                  "model-value": m.getIsVisible(),
                  "onUpdate:modelValue": (w) => {
                    var R, y;
                    return (y = (R = e.gridApi.table.value) == null ? void 0 : R.getColumn(m.id)) == null ? void 0 : y.toggleVisibility(w);
                  }
                }, null, 8, ["model-value", "onUpdate:modelValue"]),
                h("p", ul, S(((x = e.gridApi.getColumnDefinitionById(m.id)) == null ? void 0 : x.headerName) || m.id), 1)
              ]);
            }), 128))
          ])
        ])
      ]),
      _: 1
    }));
  }
}), cl = /* @__PURE__ */ V({
  __name: "VgCopyToClipboard",
  props: {
    gridApi: {},
    i18n: {}
  },
  setup(i) {
    const e = z(i.i18n.t("top_menu.tooltips.copy_to_clipboard"));
    let t = null;
    function n() {
      t && window.clearTimeout(t), e.value = i.i18n.t("top_menu.tooltips.copy_to_clipboard"), t = null;
    }
    function o() {
      e.value = i.i18n.t("top_menu.tooltips.copied_to_clipboard"), t = window.setTimeout(n, 1500);
    }
    async function r() {
      await i.gridApi.copyDataToClipboard(), o();
    }
    return (a, s) => (c(), k(l(I), {
      class: "vg-top-bar-button",
      onClick: r,
      onMouseleave: n,
      title: e.value
    }, {
      default: b(() => [
        g(l(D), { type: "clipboard-document" })
      ]),
      _: 1
    }, 8, ["title"]));
  }
}), pl = /* @__PURE__ */ V({
  __name: "VgTopMenuDelete",
  props: {
    gridApi: {},
    i18n: {}
  },
  setup(i) {
    const e = i, t = f(() => e.gridApi.table.value.getSelectedRowModel().flatRows.length > 0);
    async function n() {
      var o, r;
      e.gridApi.config.deleteCallback ? await ((r = (o = e.gridApi.config).deleteCallback) == null ? void 0 : r.call(o, {
        grid: e.gridApi,
        data: Q(e.gridApi.selectedRows.value.map((a) => U(a.original)))
      })) : console.error("No delete callback provided");
    }
    return (o, r) => (c(), k(l(I), {
      class: "vg-top-bar-button",
      disabled: !t.value,
      onClick: n,
      title: o.i18n.t("top_menu.tooltips.delete")
    }, {
      default: b(() => [
        g(l(D), { type: "trash-can-outline" })
      ]),
      _: 1
    }, 8, ["disabled", "title"]));
  }
}), gl = /* @__PURE__ */ V({
  __name: "VgTopMenuDragAndDropToggle",
  props: {
    gridApi: {},
    i18n: {}
  },
  setup(i) {
    const e = i;
    return (t, n) => (c(), k(l(I), {
      class: "vg-top-bar-button",
      active: e.gridApi.extraOptions.value.dragAndDrop,
      onClick: n[0] || (n[0] = () => e.gridApi.extraOptions.value.dragAndDrop = !e.gridApi.extraOptions.value.dragAndDrop),
      title: t.i18n.t("top_menu.tooltips.header_drag_and_drop")
    }, {
      default: b(() => [
        g(l(D), { type: "move-column" })
      ]),
      _: 1
    }, 8, ["active", "title"]));
  }
}), fl = /* @__PURE__ */ V({
  __name: "VgTopMenuEdit",
  props: {
    gridApi: {},
    i18n: {}
  },
  setup(i) {
    const e = i;
    function t() {
      var n, o;
      (o = (n = e.gridApi.config).onEditModeToggle) == null || o.call(n, {
        grid: e.gridApi,
        targetState: !e.gridApi.editing.value
      }), e.gridApi.editing.value = !e.gridApi.editing.value;
    }
    return (n, o) => e.gridApi.config.enableEditing === !0 ? (c(), k(l(I), {
      key: 0,
      class: "vg-top-bar-button",
      active: e.gridApi.editing.value,
      onClick: t,
      title: n.i18n.t("top_menu.tooltips.edit")
    }, {
      default: b(() => [
        g(l(D), { type: "pencil-outline" })
      ]),
      _: 1
    }, 8, ["active", "title"])) : M("", !0);
  }
}), vl = /* @__PURE__ */ V({
  __name: "VgTopMenuEnableDetailDrawer",
  props: {
    gridApi: {},
    i18n: {}
  },
  setup(i) {
    const e = i;
    return (t, n) => (c(), k(l(I), {
      class: "vg-top-bar-button",
      onClick: n[0] || (n[0] = () => e.gridApi.extraOptions.value.enableDetailDrawer = !e.gridApi.extraOptions.value.enableDetailDrawer),
      active: e.gridApi.extraOptions.value.enableDetailDrawer,
      title: t.i18n.t("top_menu.tooltips.enable_detail_drawer")
    }, {
      default: b(() => [
        g(l(D), { type: "grid-detail-icon" })
      ]),
      _: 1
    }, 8, ["active", "title"]));
  }
}), ml = { class: "vg-export-settings-container" }, hl = { class: "vg-export-settings-header" }, bl = { class: "vg-export-settings-wrapper" }, _l = /* @__PURE__ */ V({
  __name: "VgTopMenuExport",
  props: {
    gridApi: {},
    i18n: {}
  },
  setup(i) {
    const e = i;
    async function t(n) {
      await e.gridApi.export(n);
    }
    return (n, o) => (c(), k(l(pe), null, {
      "dropdown-anchor": b(({ dropdownActive: r }) => {
        var a;
        return [
          g(l(I), L({ class: "vg-top-bar-button" }, e, {
            disabled: !((a = n.gridApi.config.export) != null && a.exportFormats),
            title: n.i18n.t("top_menu.tooltips.export"),
            active: r
          }), {
            default: b(() => [
              g(l(D), { type: "file-export-outline" })
            ]),
            _: 2
          }, 1040, ["disabled", "title", "active"])
        ];
      }),
      default: b(() => {
        var r;
        return [
          h("div", ml, [
            h("h3", hl, S(n.i18n.t("top_menu.tooltips.export")), 1),
            h("div", bl, [
              (c(!0), _(j, null, Y(((r = n.gridApi.config.export) == null ? void 0 : r.exportFormats) || [], (a) => (c(), k(l(I), {
                onClick: async () => await t(a.format),
                variant: "tonal",
                block: "",
                key: a.format
              }, {
                prepend: b(() => [
                  g(l(D), { type: "file-export-outline" })
                ]),
                default: b(() => [
                  h("p", null, S(a.label), 1)
                ]),
                _: 2
              }, 1032, ["onClick"]))), 128))
            ])
          ])
        ];
      }),
      _: 1
    }));
  }
}), yl = /* @__PURE__ */ V({
  __name: "VgTopMenuExtraFilter",
  props: {
    filter: {}
  },
  setup(i) {
    const { gridApi: e } = H(), t = i;
    return (n, o) => (c(), k(q(l($t)(n.filter.columnType, l(e))), {
      "filter-custom-data": n.filter.columnFilterCustomData ?? {},
      "column-id": t.filter.id,
      index: 0,
      "grid-api": l(e),
      "is-in-menu": !1
    }, null, 8, ["filter-custom-data", "column-id", "grid-api"]));
  }
}), wl = { key: 0 }, Cl = {
  key: 0,
  class: "vg-top-bar-extra-filters"
}, xl = {
  key: 1,
  style: { "text-align": "center", width: "100%" }
}, Sl = /* @__PURE__ */ V({
  __name: "VgTopMenuExtraFiltersContainer",
  props: {
    extraFiltersExpanded: { type: Boolean }
  },
  setup(i) {
    Ne((t) => ({
      "4cd0f0ec": l(e).extraOptions.value.extraFiltersColumnNumber
    }));
    const { gridApi: e } = H();
    return (t, n) => {
      var o;
      return t.extraFiltersExpanded ? (c(), _("div", wl, [
        ((o = l(e).config.extraFilters) == null ? void 0 : o.length) ?? !1 ? (c(), _("div", Cl, [
          (c(!0), _(j, null, Y(l(e).config.extraFilters, (r, a) => (c(), _("div", {
            key: a,
            style: { "flex-grow": "1" },
            class: "vg-top-bar-extra-filters-content"
          }, [
            g(yl, { filter: r }, null, 8, ["filter"])
          ]))), 128))
        ])) : (c(), _("div", xl, n[0] || (n[0] = [
          h("h2", { style: { margin: "6px" } }, "No extra filters defined", -1)
        ])))
      ])) : M("", !0);
    };
  }
});
async function Vl(i) {
  const e = document.documentElement;
  e.requestFullscreen ? await e.requestFullscreen() : e.webkitRequestFullscreen ? e.webkitRequestFullscreen() : console.log("Fullscreen API is not supported as we are not in Chrome or Safari");
}
async function kl() {
  document.fullscreenEnabled !== !1 && (document.exitFullscreen ? await document.exitFullscreen() : document.webkitExitFullscreen ? document.webkitExitFullscreen() : console.log("Fullscreen API is not supported as we are not in Chrome or Safari"));
}
const Dl = /* @__PURE__ */ V({
  __name: "VgTopMenuFullscreen",
  props: {
    gridApi: {},
    i18n: {}
  },
  setup(i) {
    const e = i;
    function t(o) {
      e.gridApi.extraOptions.value.fullscreen = o, e.gridApi.config.fullscreenType === "fullscreen" && (o ? Vl() : kl());
    }
    function n() {
      // @ts-expect-error Safari
      !document.webkitIsFullScreen && // @ts-expect-error Firefox
      !document.mozFullScreen && // @ts-expect-error Internet Explorer
      !document.msFullscreenElement && document.fullscreenElement === null && (console.log("Change in fullscreen detected, exiting fullscreen"), e.gridApi.extraOptions.value.fullscreen = !1);
    }
    return Ue(() => {
      document.addEventListener("fullscreenchange", n, !1), document.addEventListener("mozfullscreenchange", n, !1), document.addEventListener("MSFullscreenChange", n, !1), document.addEventListener("webkitfullscreenchange", n, !1);
    }), st(() => {
      document.removeEventListener("fullscreenchange", n), document.removeEventListener("mozfullscreenchange", n), document.removeEventListener("MSFullscreenChange", n), document.removeEventListener("webkitfullscreenchange", n);
    }), (o, r) => e.gridApi.parentGrid === null ? (c(), k(l(I), {
      key: 0,
      class: "vg-top-bar-button",
      disabled: !(e.gridApi.config.enableFullscreen ?? !0) && e.gridApi.parentGrid !== null,
      active: e.gridApi.extraOptions.value.fullscreen,
      onClick: r[0] || (r[0] = () => t(!e.gridApi.extraOptions.value.fullscreen)),
      title: o.i18n.t("top_menu.tooltips.fullscreen")
    }, {
      default: b(() => [
        g(l(D), { type: "fullscreen" })
      ]),
      _: 1
    }, 8, ["disabled", "active", "title"])) : M("", !0);
  }
}), Rl = /* @__PURE__ */ V({
  __name: "VgTopMenuGlobalFilters",
  props: {
    gridApi: {},
    i18n: {}
  },
  setup(i) {
    const e = i;
    return (t, n) => (c(), k(l(I), {
      class: "vg-top-bar-button",
      onClick: n[0] || (n[0] = () => e.gridApi.extraOptions.value.extraFiltersVisible = !e.gridApi.extraOptions.value.extraFiltersVisible),
      active: e.gridApi.extraOptions.value.extraFiltersVisible,
      title: t.i18n.t("top_menu.tooltips.global_filters")
    }, {
      default: b(() => [
        g(l(D), { type: "tune" })
      ]),
      _: 1
    }, 8, ["active", "title"]));
  }
}), Al = /* @__PURE__ */ V({
  __name: "VgTopMenuRefresh",
  props: {
    gridApi: {},
    i18n: {}
  },
  setup(i) {
    const e = f(() => ({
      "vg-top-bar-button": !0,
      "vg-top-bar-button-refreshing": t.gridApi.state.loaderVisible
    })), t = i;
    return (n, o) => (c(), k(l(I), {
      class: X(e.value),
      onClick: o[0] || (o[0] = () => t.gridApi.fetchData()),
      title: n.i18n.t("top_menu.tooltips.refresh")
    }, {
      default: b(() => [
        g(l(D), { type: "refresh" })
      ]),
      _: 1
    }, 8, ["class", "title"]));
  }
}), Il = { class: "vg-reset-settings-container" }, Fl = { class: "vg-reset-settings-header" }, $l = /* @__PURE__ */ V({
  __name: "VgTopMenuResetSettings",
  props: {
    gridApi: {},
    i18n: {}
  },
  setup(i) {
    const e = i;
    function t() {
      e.gridApi.tableState.value.columnPinning.left = [], e.gridApi.tableState.value.columnPinning.right = [];
    }
    function n() {
      e.gridApi.tableState.value.columnOrder = [];
    }
    function o() {
      e.gridApi.tableState.value.columnSizing = {};
    }
    function r() {
      e.gridApi.tableState.value.sorting = [];
    }
    function a() {
      e.gridApi.tableState.value.columnVisibility = {};
    }
    function s() {
      var v;
      e.gridApi.extraOptions.value.accessibility = {
        ...e.gridApi.defaultExtraOptions.accessibility || {},
        ...((v = e.gridApi.config.extraOptions) == null ? void 0 : v.accessibility) || {}
      };
    }
    function u() {
      t(), n(), o(), r(), a(), s();
    }
    return (v, p) => (c(), k(l(pe), null, {
      "dropdown-anchor": b(({ dropdownActive: d }) => [
        g(l(I), {
          class: "vg-top-bar-button",
          title: v.i18n.t("top_menu.tooltips.reset_settings"),
          active: d
        }, {
          default: b(() => [
            g(l(D), { type: "user-reload" })
          ]),
          _: 2
        }, 1032, ["title", "active"])
      ]),
      default: b(() => [
        h("div", Il, [
          h("h3", Fl, S(v.i18n.t("top_menu.tooltips.reset_settings")), 1),
          g(l(I), {
            onClick: t,
            block: ""
          }, {
            prepend: b(() => [
              g(l(D), { type: "lock-left" })
            ]),
            default: b(() => [
              h("p", null, S(v.i18n.t("top_menu.reset_settings.column_pinning")), 1)
            ]),
            _: 1
          }),
          g(l(I), {
            onClick: n,
            block: ""
          }, {
            prepend: b(() => [
              g(l(D), { type: "controls-prev" })
            ]),
            default: b(() => [
              h("p", null, S(v.i18n.t("top_menu.reset_settings.column_order")), 1)
            ]),
            _: 1
          }),
          g(l(I), {
            onClick: o,
            block: ""
          }, {
            prepend: b(() => [
              g(l(D), { type: "user-reload" })
            ]),
            default: b(() => [
              h("p", null, S(v.i18n.t("top_menu.reset_settings.column_sizing")), 1)
            ]),
            _: 1
          }),
          g(l(I), {
            onClick: r,
            block: ""
          }, {
            prepend: b(() => [
              g(l(D), { type: "chevron-down" })
            ]),
            default: b(() => [
              h("p", null, S(v.i18n.t("top_menu.reset_settings.column_sorting")), 1)
            ]),
            _: 1
          }),
          g(l(I), {
            onClick: a,
            block: ""
          }, {
            prepend: b(() => [
              g(l(D), { type: "eye-off-outline" })
            ]),
            default: b(() => [
              h("p", null, S(v.i18n.t("top_menu.reset_settings.column_visibility")), 1)
            ]),
            _: 1
          }),
          g(l(I), {
            onClick: s,
            block: ""
          }, {
            prepend: b(() => [
              g(l(D), { type: "format-font" })
            ]),
            default: b(() => [
              h("p", null, S(v.i18n.t("top_menu.reset_settings.accessibility")), 1)
            ]),
            _: 1
          }),
          p[0] || (p[0] = h("hr", { class: "vg-divider-horizontal" }, null, -1)),
          g(l(I), {
            onClick: u,
            block: ""
          }, {
            prepend: b(() => [
              g(l(D), { type: "refresh" })
            ]),
            default: b(() => [
              h("p", null, S(v.i18n.t("top_menu.reset_settings.all")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }));
  }
}), Ol = /* @__PURE__ */ V({
  __name: "VgTopMenuSave",
  props: {
    gridApi: {},
    i18n: {}
  },
  setup(i) {
    const e = i;
    async function t() {
      e.gridApi.config.saveCallback ? await e.gridApi.saveChanges() : console.error("No save callback provided");
    }
    const n = f(() => ({
      "vg-top-bar-save-button-active": e.gridApi.updatedData.length > 0 || e.gridApi.areSubgridsUpdated.value
    }));
    return (o, r) => (c(), k(l(Ge), {
      value: e.gridApi.updatedData.length,
      show: e.gridApi.updatedData.length > 0,
      size: "16px",
      fontSize: "12px",
      class: "vg-top-bar-save-button-badge"
    }, {
      default: b(() => [
        g(l(I), {
          class: X(["vg-top-bar-button", n.value]),
          disabled: e.gridApi.updatedData.length === 0 && !e.gridApi.areSubgridsUpdated.value,
          title: o.i18n.t("top_menu.tooltips.save"),
          onClick: t
        }, {
          default: b(() => [
            g(l(D), { type: "content-save-outline" })
          ]),
          _: 1
        }, 8, ["disabled", "class", "title"])
      ]),
      _: 1
    }, 8, ["value", "show"]));
  }
});
function ha(...i) {
  const e = /* @__PURE__ */ new Set();
  return i.forEach((t) => {
    Pn(t) && t.forEach((n) => e.add(n)), At(t) && e.add(t), $e(t) && Object.entries(t).forEach(([n, o]) => {
      o ? e.add(n) : e.delete(n);
    });
  }), Array.from(e).filter(Boolean);
}
const Pl = ["data-selectable-cells"], zl = { class: "vg-table-wrapper" }, ba = /* @__PURE__ */ V({
  __name: "VgGrid",
  props: {
    gridApi: {}
  },
  setup(i) {
    Ne((u) => ({
      "88a83c9e": o.value,
      "5820958e": r.value,
      bd9ee638: a.value
    }));
    const e = z(null), t = i, { gridApi: n } = t;
    n.i18n.value = ae(n.config.i18n), Fe(kt, n.getCtx()), tn(() => {
      n.onBeforeMount();
    }), Ue(async () => {
      n.rootElement.value = e.value, await n.onMounted();
    }), nn(() => {
      n.onBeforeUnmount();
    });
    const o = f(() => n.extraOptions.value.accessibility.fontFamily), r = f(() => n.extraOptions.value.accessibility.fontSize), a = f(() => n.extraOptions.value.accessibility.rowHeightMultiplier ?? 1), s = f(() => ({
      "vg-grid": !0,
      "vg-grid-subgrid": n.parentGrid !== null,
      "vg-grid--has-edits": n.updatedData.length > 0
    }));
    return (u, v) => (c(), _("div", {
      class: X(s.value),
      ref_key: "gridElement",
      ref: e,
      "data-selectable-cells": l(n).state.selectableCells
    }, [
      h("div", zl, [
        g(l(_i))
      ])
    ], 10, Pl));
  }
}), _a = {
  gridApi: {
    type: Object,
    required: !0
  }
}, ya = {
  pageSize: {
    type: Number,
    required: !0
  },
  pageCount: {
    type: Number,
    required: !0
  },
  pageCountOptions: {
    type: Array,
    required: !0
  },
  pageNumber: {
    type: Number,
    required: !0
  },
  pageIndex: {
    type: Number,
    required: !0
  },
  enabledGoNextPage: {
    type: Boolean,
    required: !0
  },
  enabledGoPreviousPage: {
    type: Boolean,
    required: !0
  },
  setPageSize: {
    type: Function,
    required: !0
  },
  goFirstPage: {
    type: Function,
    required: !0
  },
  setPageIndex: {
    type: Function,
    required: !0
  },
  goPreviousPage: {
    type: Function,
    required: !0
  },
  goNextPage: {
    type: Function,
    required: !0
  },
  goLastPage: {
    type: Function,
    required: !0
  }
}, Ml = { class: "vg-pagination" }, El = { class: "vg-pagination__section vg-pagination__section--nav-buttons" }, Tl = { class: "vg-pagination__section vg-pagination__section--info" }, Bl = { class: "vg-pagination__message vg-pagination__label" }, Nl = { class: "vg-pagination__section vg-pagination__section--go-to" }, Ul = { class: "vg-pagination__section vg-pagination__section--items-per-page" }, Hl = {
  key: 0,
  class: "vg-pagination__section vg-pagination__section--total-row-count"
}, Gl = /* @__PURE__ */ V({
  __name: "VgPagination",
  props: {
    pageCountOptions: {},
    pageSize: {},
    setPageSize: { type: Function },
    pageCount: {},
    pageIndex: {},
    setPageIndex: { type: Function },
    pageNumber: {},
    enabledGoNextPage: { type: Boolean },
    enabledGoPreviousPage: { type: Boolean },
    goPreviousPage: { type: Function },
    goNextPage: { type: Function },
    goFirstPage: { type: Function },
    goLastPage: { type: Function }
  },
  setup(i) {
    const e = i, {
      i18n: { t },
      gridApi: n
    } = H(), o = z(e.pageNumber);
    de(
      () => e.pageNumber,
      (u) => {
        o.value = u;
      }
    );
    function r() {
      const u = o.value;
      Mn(u) && u > 0 && u <= e.pageCount && u !== e.pageNumber && e.setPageIndex(u - 1);
    }
    const a = f({
      get() {
        return e.pageSize;
      },
      set(u) {
        e.setPageSize(u);
      }
    }), s = f(() => {
      const u = [];
      for (const v of e.pageCountOptions)
        u.push({ title: v === null ? t("pagination.all") : v.toString(), value: v });
      return u;
    });
    return (u, v) => (c(), _("div", Ml, [
      h("section", El, [
        g(l(I), {
          class: "vg-pagination__nav-button",
          disabled: !u.enabledGoPreviousPage,
          onClick: v[0] || (v[0] = (p) => u.goFirstPage())
        }, {
          default: b(() => [
            g(l(D), { type: "chevron-double-left" })
          ]),
          _: 1
        }, 8, ["disabled"]),
        g(l(I), {
          class: "vg-pagination__nav-button",
          onClick: v[1] || (v[1] = (p) => u.goPreviousPage()),
          disabled: !u.enabledGoPreviousPage
        }, {
          default: b(() => [
            g(l(D), { type: "chevron-left" })
          ]),
          _: 1
        }, 8, ["disabled"]),
        g(l(I), {
          class: "vg-pagination__nav-button",
          disabled: !u.enabledGoNextPage,
          onClick: v[2] || (v[2] = (p) => u.goNextPage())
        }, {
          default: b(() => [
            g(l(D), { type: "chevron-right" })
          ]),
          _: 1
        }, 8, ["disabled"]),
        g(l(I), {
          class: "vg-pagination__nav-button",
          disabled: !u.enabledGoNextPage,
          onClick: v[3] || (v[3] = (p) => u.goLastPage())
        }, {
          default: b(() => [
            g(l(D), { type: "chevron-double-right" })
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      h("div", Tl, [
        h("div", Bl, [
          h("div", Nl, [
            g(l(oe), {
              modelValue: o.value,
              "onUpdate:modelValue": v[4] || (v[4] = (p) => o.value = p),
              modelModifiers: { number: !0 },
              label: l(t)("pagination.goToPage"),
              type: "number",
              min: 1,
              max: u.pageCount,
              onFocusout: r,
              onKeydown: at(r, ["enter"])
            }, null, 8, ["modelValue", "label", "max"])
          ]),
          h("div", null, " " + S(l(t)("pagination.of")) + " ", 1),
          h("div", null, S(u.pageCount), 1)
        ])
      ]),
      h("div", Ul, [
        g(l(se), {
          label: l(t)("pagination.itemsPerPage"),
          modelValue: a.value,
          "onUpdate:modelValue": v[5] || (v[5] = (p) => a.value = p),
          items: s.value
        }, null, 8, ["label", "modelValue", "items"])
      ]),
      l(n).state.totalRowCount ? (c(), _("div", Hl, [
        h("div", null, S(l(t)("pagination.totalRowCount")) + ": " + S(l(n).state.totalRowCount), 1)
      ])) : M("", !0)
    ]));
  }
}), ql = { class: "vg-pagination-wrapper" }, Wl = /* @__PURE__ */ V({
  __name: "VgPaginationWrapper",
  setup(i) {
    const { gridApi: e } = H(), t = he({
      pageCountOptions: e.datasource.pageCountOptions,
      enabledGoPreviousPage: f(() => e.table.value.getCanPreviousPage()),
      enabledGoNextPage: f(() => e.table.value.getCanNextPage()),
      pageCount: f(() => e.table.value.getPageCount()),
      pageNumber: f(() => e.tableState.value.pagination.pageIndex + 1),
      pageIndex: f(() => e.tableState.value.pagination.pageIndex),
      pageSize: f(() => e.tableState.value.pagination.pageSize),
      goFirstPage: () => {
        e.table.value.setPageIndex(0);
      },
      goLastPage: () => {
        e.table.value.setPageIndex(e.table.value.getPageCount() - 1);
      },
      goNextPage: () => {
        e.table.value.nextPage();
      },
      goPreviousPage: () => {
        e.table.value.previousPage();
      },
      setPageIndex: (n) => {
        const o = e.table.value.getPageCount();
        let r = 0;
        n < 0 ? r = 0 : n > o - 1 ? r = o - 1 : r = n, e.table.value.setPageIndex(r);
      },
      setPageSize: (n) => {
        e.table.value.setPageSize(n);
      }
    });
    return (n, o) => (c(), _("div", ql, [
      J(n.$slots, "default", { paginationProps: t })
    ]));
  }
});
function wa(i, e, t) {
  const { debounceTimeout: n = 350 } = t ?? {}, o = vn((a) => {
    e(a);
  }, n), r = f({
    get() {
      return fe(i);
    },
    set(a) {
      o(a);
    }
  });
  return st(() => {
    o.cancel();
  }), {
    value: r,
    cancel: o.cancel
  };
}
export {
  ri as Filters,
  Sa as FlexRender,
  da as GridApi,
  we as GridApiEventKey,
  et as NoMoreDataError,
  Me as StorageController,
  Tt as VG_ROW_DRAG_HANDLE_WIDTH,
  Mt as VG_ROW_EXPANDER_WIDTH,
  Et as VG_ROW_SELECTION_WIDTH,
  si as Validator,
  Ge as VgBadge,
  Ui as VgBody,
  Oi as VgBodyCellBoolean,
  Gi as VgBodyCellDNDHandle,
  Ji as VgBodyCellEdit,
  Xi as VgBodyCellExpander,
  Qi as VgBodyCellSelect,
  nt as VgBodyCellText,
  no as VgBodyCellWrapper,
  lo as VgBodyFetchMore,
  ot as VgBodyRow,
  uo as VgBodyRowDetail,
  lt as VgBodyRowWrapper,
  I as VgButton,
  Rn as VgCheckbox,
  Bn as VgColumnFilterBoolean,
  Nn as VgColumnFilterCombo,
  Un as VgColumnFilterDate,
  Hn as VgColumnFilterNumber,
  Gn as VgColumnFilterSelect,
  Ke as VgColumnFilterText,
  Xn as VgColumnFilterWrapper,
  fo as VgDetailDrawer,
  _o as VgDetailDrawerSimple,
  fa as VgDetailDrawerWithComponents,
  An as VgDrawer,
  pe as VgDropdown,
  zi as VgEditCellBoolean,
  Mi as VgEditCellNumber,
  Ei as VgEditCellSelect,
  it as VgEditCellText,
  ba as VgGrid,
  Ro as VgHeader,
  Mo as VgHeaderCell,
  Eo as VgHeaderCellDNDHandle,
  Bo as VgHeaderCellExpander,
  Uo as VgHeaderCellSelect,
  Go as VgHeaderCellWrapper,
  Lo as VgHeaderRow,
  Vo as VgHeaderRowWrapper,
  D as VgIcon,
  oe as VgInput,
  Fn as VgLoader,
  Gl as VgPagination,
  Wl as VgPaginationWrapper,
  se as VgSelect,
  _i as VgTable,
  Fi as VgTopMenu,
  il as VgTopMenuAccessibility,
  ol as VgTopMenuClearFilters,
  dl as VgTopMenuColumnVisibility,
  cl as VgTopMenuCopyToClipboard,
  pl as VgTopMenuDelete,
  gl as VgTopMenuDragAndDropToggle,
  fl as VgTopMenuEdit,
  vl as VgTopMenuEnableDetailDrawer,
  _l as VgTopMenuExport,
  yl as VgTopMenuExtraFilter,
  Sl as VgTopMenuExtraFiltersContainer,
  Dl as VgTopMenuFullscreen,
  Rl as VgTopMenuGlobalFilters,
  Al as VgTopMenuRefresh,
  $l as VgTopMenuResetSettings,
  Ol as VgTopMenuSave,
  Ve as calculateOffset,
  ge as createColumn,
  oi as createColumns,
  ae as createI18n,
  ii as createSelectedCellsApi,
  li as createTable,
  ai as createUtils,
  ca as decodeRowDetailID,
  re as deepcopy,
  ci as encodeRowDetailID,
  aa as forEachArray,
  Oe as getBodyCellProps,
  _e as getColumnMeta,
  En as getHeaderCellProps,
  ee as getRelation,
  pi as getRowDetailID,
  Gt as getTableMeta,
  Ci as getTopMenuDefaultButtonsAlwaysVisible,
  xi as getTopMenuDefaultButtonsAlwaysVisibleHeader,
  wi as getTopMenuDefaultButtonsCollapsible,
  kt as gridGlobalCtxKey,
  Pn as isArray,
  zn as isEqualObj,
  ve as isFunction,
  sa as isNull,
  Mn as isNumber,
  $e as isObject,
  ke as isRowDetail,
  At as isString,
  ia as localeCs,
  oa as localeEn,
  la as localeSk,
  Q as makeClone,
  ra as mapArray,
  di as mapCellsTo2DArrayValues,
  ha as mergeCSSClassValues,
  Tn as resolveBodyCellComponent,
  $t as resolveColumnFilterComponent,
  Yn as resolveComponentsPool,
  Qn as resolveDatasource,
  yi as resolveTopMenuComponent,
  ne as resolveUpdaterValue,
  K as sanitizeComponentFromPool,
  Ce as sharedBus,
  H as useGridContext,
  wa as useValueDebounced,
  ga as vgBodyCellProps,
  pa as vgBodyRowProps,
  _a as vgGridProps,
  va as vgHeaderCellProps,
  ma as vgHeaderRowProps,
  ua as vgIconProps,
  ya as vgPaginationProps
};
//# sourceMappingURL=vue-grid.es.js.map
